var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialMovementsNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Material_Movements",
    "data-name": "Material Movements",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 91.84,
    viewBox: "0 0 150 91.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #4f1f26;\n      }\n\n      .cls-4 {\n        fill: #5d3138;\n      }\n\n      .cls-5 {\n        fill: #816065;\n      }\n\n      .cls-6 {\n        fill: #380009;\n      }\n\n      .cls-7 {\n        fill: #ba9c8c;\n      }\n\n      .cls-8 {\n        fill: #8c7370;\n      }\n\n      .cls-9 {\n        fill: #bb5900;\n      }\n\n      .cls-10 {\n        fill: #e28b00;\n      }\n\n      .cls-11 {\n        fill: #bb5300;\n      }\n\n      .cls-12 {\n        fill: #9b7a6d;\n      }\n\n      .cls-13 {\n        fill: #bc998e;\n      }\n\n      .cls-14 {\n        fill: #b74200;\n      }\n\n      .cls-15 {\n        fill: #ce5d3a;\n      }\n\n      .cls-16 {\n        fill: #a33400;\n      }\n\n      .cls-17 {\n        fill: #ce7731;\n      }\n\n      .cls-18 {\n        fill: #2d191d;\n      }\n\n      .cls-19 {\n        fill: #4a3f40;\n      }\n\n      .cls-20 {\n        fill: #cb5200;\n      }\n\n      .cls-21 {\n        fill: #ff9e42;\n      }\n\n      .cls-22 {\n        fill: #ed8725;\n      }\n\n      .cls-23 {\n        fill: #ffb357;\n      }\n\n      .cls-24 {\n        fill: #ff9700;\n      }\n\n      .cls-25 {\n        fill: #b84c21;\n      }\n\n      .cls-26 {\n        fill: #f5a355;\n      }\n\n      .cls-27 {\n        fill: #a83c00;\n      }\n\n      .cls-28 {\n        fill: #896a6d;\n      }\n\n      .cls-29 {\n        fill: #d37d33;\n      }\n\n      .cls-30 {\n        fill: #dd6617;\n      }\n\n      .cls-31 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-31, .cls-55 {\n        isolation: isolate;\n      }\n\n      .cls-32 {\n        clip-path: url(#clip-path-3);\n      }\n\n      .cls-33 {\n        fill: #beb5af;\n      }\n\n      .cls-34 {\n        fill: #2f2728;\n      }\n\n      .cls-35 {\n        fill: #49383b;\n      }\n\n      .cls-36 {\n        fill: #362e2f;\n      }\n\n      .cls-37 {\n        fill: #352428;\n      }\n\n      .cls-38 {\n        fill: #47220b;\n      }\n\n      .cls-39 {\n        clip-path: url(#clip-path-4);\n      }\n\n      .cls-40 {\n        fill: #b09287;\n      }\n\n      .cls-41 {\n        fill: #3a2227;\n      }\n\n      .cls-42 {\n        fill: #493538;\n      }\n\n      .cls-43 {\n        fill: #5b4548;\n      }\n\n      .cls-44 {\n        fill: #49383c;\n      }\n\n      .cls-45 {\n        fill: #23191d;\n      }\n\n      .cls-46 {\n        fill: #352a2d;\n      }\n\n      .cls-47 {\n        fill: #ea7513;\n      }\n\n      .cls-48 {\n        fill: #63474b;\n      }\n\n      .cls-49 {\n        fill: #9e8587;\n      }\n\n      .cls-50 {\n        fill: #d8661a;\n      }\n\n      .cls-51 {\n        fill: #ffc55f;\n      }\n\n      .cls-52 {\n        fill: #6d5358;\n      }\n\n      .cls-53 {\n        fill: #231015;\n      }\n\n      .cls-54 {\n        fill: #e5ccb5;\n      }\n\n      .cls-55 {\n        mix-blend-mode: screen;\n      }\n\n      .cls-56 {\n        clip-path: url(#clip-path-5);\n      }\n\n      .cls-57 {\n        fill: #ff5f2e;\n      }\n\n      .cls-58 {\n        fill: #1f140b;\n      }\n\n      .cls-59 {\n        fill: #331818;\n      }\n\n      .cls-60 {\n        fill: #ffefd2;\n      }\n\n      .cls-61 {\n        fill: #67383f;\n      }\n\n      .cls-62 {\n        fill: #a97f7f;\n      }\n\n      .cls-63 {\n        fill: #a87b80;\n      }\n\n      .cls-64 {\n        fill: #f2efe2;\n      }\n\n      .cls-65 {\n        fill: #4f2f32;\n      }\n\n      .cls-66 {\n        fill: #d0b6b3;\n      }\n\n      .cls-67 {\n        fill: #e5d6be;\n      }\n\n      .cls-68 {\n        fill: #f1f1f1;\n      }\n\n      .cls-69 {\n        fill: #dff1f1;\n      }\n\n      .cls-70 {\n        fill: #423d3d;\n      }\n\n      .cls-71 {\n        fill: #fff;\n      }\n\n      .cls-72 {\n        fill: #716d6d;\n      }\n\n      .cls-73 {\n        fill: #a3a8b1;\n      }\n\n      .cls-74 {\n        fill: #c12f1b;\n      }\n\n      .cls-75 {\n        fill: #e2d9bc;\n      }\n\n      .cls-76 {\n        fill: #664a4c;\n      }\n\n      .cls-77 {\n        clip-path: url(#clip-path-6);\n      }\n\n      .cls-78 {\n        fill: #dfd4cd;\n      }\n\n      .cls-79 {\n        clip-path: url(#clip-path-7);\n      }\n\n      .cls-80 {\n        fill: #e7ce68;\n      }\n\n      .cls-81 {\n        clip-path: url(#clip-path-8);\n      }\n\n      .cls-82 {\n        clip-path: url(#clip-path-9);\n      }\n\n      .cls-83 {\n        fill: #bfa89a;\n      }\n\n      .cls-84 {\n        fill: #e2cfc7;\n      }\n\n      .cls-85 {\n        fill: #dc6e36;\n      }\n\n      .cls-86 {\n        fill: #ff8936;\n      }\n\n      .cls-87 {\n        fill: #d75716;\n      }\n\n      .cls-88 {\n        fill: #ddd;\n      }\n\n      .cls-89 {\n        fill: #ff9e38;\n      }\n\n      .cls-90 {\n        fill: #902e00;\n      }\n\n      .cls-91 {\n        fill: #983800;\n      }\n\n      .cls-92 {\n        clip-path: url(#clip-path-10);\n      }\n\n      .cls-93 {\n        fill: #d8d8d8;\n      }\n\n      .cls-94 {\n        fill: #d76600;\n      }\n\n      .cls-95 {\n        fill: #ffa71e;\n      }\n\n      .cls-96 {\n        fill: #ff9c00;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26801",
    "data-name": "Rectangle 26801",
    className: "cls-1",
    width: 150,
    height: 91.84
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26792",
    "data-name": "Rectangle 26792",
    className: "cls-1",
    width: 4.197,
    height: 8.987
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26793",
    "data-name": "Rectangle 26793",
    className: "cls-1",
    width: 14.446,
    height: 4.912
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26794",
    "data-name": "Rectangle 26794",
    className: "cls-1",
    width: 34.349,
    height: 17.506
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26795",
    "data-name": "Rectangle 26795",
    className: "cls-1",
    width: 6.806,
    height: 19.333
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26796",
    "data-name": "Rectangle 26796",
    className: "cls-1",
    width: 24.059,
    height: 29.319
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26797",
    "data-name": "Rectangle 26797",
    className: "cls-1",
    width: 9.907,
    height: 5.903
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26798",
    "data-name": "Rectangle 26798",
    className: "cls-1",
    width: 37.034,
    height: 13.076
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26799",
    "data-name": "Rectangle 26799",
    className: "cls-1",
    width: 5.077,
    height: 1.555
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_72796",
    "data-name": "Group 72796",
    className: "cls-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72795",
    "data-name": "Group 72795",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72794",
    "data-name": "Group 72794",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78524",
    "data-name": "Path 78524",
    className: "cls-3",
    d: "M98.518,43.691,50.324,15.866c-2.011-1.16-3.826-1.362-5.119-.75v0l-.027.016a3.109,3.109,0,0,0-.4.227l-8.639,4.981.923.869L40.2,24.739c.17,3.925,5.215,3.966,9.035,6.172L92.9,56.121l2.15,7.7,8.707-5.027c.074-.039.147-.082.219-.127l.026-.015-1.092.631c1.02-.659,2.725-2.537,2.725-4.283,0-3.98-3.184-9.046-7.113-11.314",
    transform: "translate(-7.196 -2.942)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78525",
    "data-name": "Path 78525",
    className: "cls-4",
    d: "M45.313,17.174l6.356-1.241a9.936,9.936,0,0,0-.789-.792l-6.06,1.226-3.041,4.185.44.838Z",
    transform: "translate(-8.319 -3.015)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78526",
    "data-name": "Path 78526",
    className: "cls-4",
    d: "M50.26,19.989l6.356-1.241a10.035,10.035,0,0,0-.788-.792l-6.061,1.226-3.041,4.185.441.838Z",
    transform: "translate(-9.304 -3.575)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78527",
    "data-name": "Path 78527",
    className: "cls-4",
    d: "M55.207,22.8l6.356-1.241a10.077,10.077,0,0,0-.789-.792L54.714,22l-3.042,4.185.441.838Z",
    transform: "translate(-10.288 -4.136)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78528",
    "data-name": "Path 78528",
    className: "cls-4",
    d: "M60.155,25.619l6.356-1.241a9.935,9.935,0,0,0-.789-.792l-6.06,1.226L56.621,29l.44.838Z",
    transform: "translate(-11.274 -4.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78529",
    "data-name": "Path 78529",
    className: "cls-4",
    d: "M65.1,28.435l6.356-1.241a10.078,10.078,0,0,0-.789-.792l-6.06,1.226-3.042,4.185.441.838Z",
    transform: "translate(-12.259 -5.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78530",
    "data-name": "Path 78530",
    className: "cls-4",
    d: "M70.049,31.25l6.356-1.241a9.937,9.937,0,0,0-.789-.792l-6.06,1.226-3.041,4.185.44.838Z",
    transform: "translate(-13.244 -5.817)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78531",
    "data-name": "Path 78531",
    className: "cls-4",
    d: "M75,34.065l6.356-1.241a9.94,9.94,0,0,0-.789-.792L74.5,33.258l-3.04,4.185.44.838Z",
    transform: "translate(-14.229 -6.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78532",
    "data-name": "Path 78532",
    className: "cls-4",
    d: "M79.944,36.88,86.3,35.639a10.08,10.08,0,0,0-.789-.792l-6.06,1.226-3.042,4.185.441.838Z",
    transform: "translate(-15.214 -6.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78533",
    "data-name": "Path 78533",
    className: "cls-4",
    d: "M84.891,39.7l6.356-1.241a9.938,9.938,0,0,0-.789-.792L84.4,38.888l-3.041,4.185.44.838Z",
    transform: "translate(-16.199 -7.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78534",
    "data-name": "Path 78534",
    className: "cls-4",
    d: "M89.838,42.511l6.356-1.241a9.936,9.936,0,0,0-.789-.792L89.345,41.7,86.3,45.889l.441.838Z",
    transform: "translate(-17.184 -8.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78535",
    "data-name": "Path 78535",
    className: "cls-4",
    d: "M94.786,45.326l6.356-1.241a10.079,10.079,0,0,0-.789-.792l-6.06,1.226L91.251,48.7l.441.838Z",
    transform: "translate(-18.169 -8.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78536",
    "data-name": "Path 78536",
    className: "cls-4",
    d: "M99.733,48.141l6.356-1.241a9.935,9.935,0,0,0-.789-.792l-6.06,1.226L96.2,51.519l.441.838Z",
    transform: "translate(-19.154 -9.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78537",
    "data-name": "Path 78537",
    className: "cls-4",
    d: "M104.681,50.956l6.355-1.241a9.936,9.936,0,0,0-.789-.792l-6.06,1.226-3.041,4.185.44.838Z",
    transform: "translate(-20.139 -9.741)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78538",
    "data-name": "Path 78538",
    className: "cls-4",
    d: "M109.56,53.848l6.356-1.241a9.935,9.935,0,0,0-.789-.792l-6.06,1.226-3.041,4.185.44.838Z",
    transform: "translate(-21.111 -10.317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78539",
    "data-name": "Path 78539",
    className: "cls-4",
    d: "M112.989,58.392l6.356-1.241a9.937,9.937,0,0,0-.789-.792l-6.06,1.226-3.041,4.185.44.838Z",
    transform: "translate(-21.794 -11.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78540",
    "data-name": "Path 78540",
    className: "cls-4",
    d: "M114.587,63.562l6.356-1.241a9.937,9.937,0,0,0-.789-.792l-6.06,1.226-3.041,4.185.441.838Z",
    transform: "translate(-22.112 -12.251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78541",
    "data-name": "Path 78541",
    className: "cls-4",
    d: "M114.658,69.253l6.356-1.241a10.079,10.079,0,0,0-.789-.792l-6.06,1.226-3.042,4.185.441.838Z",
    transform: "translate(-22.126 -13.384)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78542",
    "data-name": "Path 78542",
    className: "cls-5",
    d: "M41.22,22.136,89.415,49.961c3.929,2.268,7.114,7.334,7.114,11.314s-3.185,5.368-7.114,3.1L41.22,36.551c-3.929-2.269-7.113-7.335-7.113-11.314s3.184-5.368,7.113-3.1",
    transform: "translate(-6.791 -4.191)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78543",
    "data-name": "Path 78543",
    className: "cls-3",
    d: "M95.437,60.9a4.612,4.612,0,0,1-.1.98c-.5,2.272-2.8,2.884-5.561,1.291L41.582,35.346c-3.121-1.8-5.66-5.752-5.66-8.807,0-2.642,1.9-3.76,4.436-2.846a7.683,7.683,0,0,1,1.224.575L89.776,52.093c3.122,1.8,5.661,5.754,5.661,8.807",
    transform: "translate(-7.152 -4.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78544",
    "data-name": "Path 78544",
    className: "cls-6",
    d: "M96.515,60.978a4.613,4.613,0,0,1-.1.98,7.6,7.6,0,0,1-1.224-.577L47,33.557c-3.122-1.8-5.661-5.753-5.661-8.806a4.609,4.609,0,0,1,.1-.979,7.684,7.684,0,0,1,1.224.575l2.485,1.435,1.152.665,4.956,2.861,7.373,4.258.032.018,1.609.928,1.153.666,3.231,1.866,5.141,2.968,6.475,3.737.751.435.16.092,2.584,1.492,1.106.639,2.685,1.55L89.346,51.3l1.508.871c.142.082.283.168.422.259a10.615,10.615,0,0,1,1.243.947c2.311,2.032,4,5.114,4,7.6",
    transform: "translate(-8.231 -4.733)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78545",
    "data-name": "Path 78545",
    className: "cls-7",
    d: "M75.661,50.855c0,1.294-.914,1.815-2.041,1.164A4.5,4.5,0,0,1,71.577,48.5c0-1.293.915-1.815,2.042-1.164a4.5,4.5,0,0,1,2.041,3.522",
    transform: "translate(-14.252 -9.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78546",
    "data-name": "Path 78546",
    className: "cls-8",
    d: "M75.514,50.478c0,1.1-.78,1.55-1.743.994a3.842,3.842,0,0,1-1.744-3.007c0-1.1.781-1.55,1.744-.994a3.841,3.841,0,0,1,1.743,3.007",
    transform: "translate(-14.342 -9.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78547",
    "data-name": "Path 78547",
    className: "cls-3",
    d: "M47.8,31.861c0,1.68-1.187,2.357-2.652,1.512A5.845,5.845,0,0,1,42.494,28.8c0-1.68,1.188-2.357,2.652-1.512A5.843,5.843,0,0,1,47.8,31.861",
    transform: "translate(-8.461 -5.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78548",
    "data-name": "Path 78548",
    className: "cls-3",
    d: "M47.2,30.145l-1.324.576a4.658,4.658,0,0,1,.56,2.331C46.4,34.4,46.17,34.3,46.17,34.3l-1.373.474-3.422-6.611L43.2,27.049,45.3,28.173Z",
    transform: "translate(-8.238 -5.386)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78549",
    "data-name": "Path 78549",
    className: "cls-7",
    d: "M45.643,33.194c0,1.68-1.187,2.357-2.652,1.511a5.842,5.842,0,0,1-2.652-4.573c0-1.68,1.188-2.357,2.652-1.512a5.843,5.843,0,0,1,2.652,4.574",
    transform: "translate(-8.032 -5.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78550",
    "data-name": "Path 78550",
    className: "cls-8",
    d: "M45.1,33.009c0,1.225-.866,1.719-1.933,1.1a4.257,4.257,0,0,1-1.933-3.334c0-1.225.865-1.719,1.933-1.1A4.258,4.258,0,0,1,45.1,33.009",
    transform: "translate(-8.211 -5.856)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78551",
    "data-name": "Path 78551",
    className: "cls-3",
    d: "M87.385,54.287c0,1.68-1.187,2.357-2.652,1.512a5.845,5.845,0,0,1-2.652-4.574c0-1.68,1.188-2.357,2.652-1.512a5.843,5.843,0,0,1,2.652,4.574",
    transform: "translate(-16.343 -9.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78552",
    "data-name": "Path 78552",
    className: "cls-3",
    d: "M86.79,52.572l-1.324.576a4.658,4.658,0,0,1,.56,2.331c-.037,1.346-.268,1.245-.268,1.245l-1.373.474-3.422-6.611,1.823-1.112L84.892,50.6Z",
    transform: "translate(-16.121 -9.851)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78553",
    "data-name": "Path 78553",
    className: "cls-7",
    d: "M85.231,55.621c0,1.68-1.187,2.357-2.652,1.511a5.842,5.842,0,0,1-2.652-4.573c0-1.68,1.188-2.357,2.652-1.512a5.843,5.843,0,0,1,2.652,4.574",
    transform: "translate(-15.915 -10.092)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78554",
    "data-name": "Path 78554",
    className: "cls-8",
    d: "M84.692,55.436c0,1.225-.866,1.719-1.933,1.1A4.257,4.257,0,0,1,80.826,53.2c0-1.225.865-1.719,1.933-1.1a4.258,4.258,0,0,1,1.933,3.334",
    transform: "translate(-16.093 -10.321)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78555",
    "data-name": "Path 78555",
    className: "cls-3",
    d: "M69.37,44.015c0,1.68-1.187,2.357-2.652,1.512a5.845,5.845,0,0,1-2.652-4.574c0-1.68,1.188-2.357,2.652-1.512a5.843,5.843,0,0,1,2.652,4.574",
    transform: "translate(-12.756 -7.781)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78556",
    "data-name": "Path 78556",
    className: "cls-3",
    d: "M68.775,42.3l-1.324.576a4.658,4.658,0,0,1,.56,2.331c-.037,1.345-.268,1.245-.268,1.245l-1.373.474-3.422-6.611L64.771,39.2l2.106,1.124Z",
    transform: "translate(-12.534 -7.806)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78557",
    "data-name": "Path 78557",
    className: "cls-7",
    d: "M67.216,45.348c0,1.68-1.187,2.357-2.652,1.511a5.842,5.842,0,0,1-2.652-4.573c0-1.68,1.188-2.357,2.652-1.512a5.843,5.843,0,0,1,2.652,4.574",
    transform: "translate(-12.328 -8.046)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78558",
    "data-name": "Path 78558",
    className: "cls-8",
    d: "M66.677,45.163c0,1.225-.866,1.719-1.933,1.1a4.258,4.258,0,0,1-1.933-3.334c0-1.225.866-1.719,1.933-1.1a4.258,4.258,0,0,1,1.933,3.334",
    transform: "translate(-12.506 -8.276)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78559",
    "data-name": "Path 78559",
    className: "cls-9",
    d: "M87.943,50.445l-1.06.977-2.459,1.294,0,0h0l-7.228-8.288-.328-.375,7.226,4.172,2.745,1.584Z",
    transform: "translate(-15.305 -8.771)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78560",
    "data-name": "Path 78560",
    className: "cls-10",
    d: "M84.069,48.207l-2.414,2.907h0L63.866,40.842l-.9-4.82,5.993,3.461L74.1,42.451l7.226,4.172Z",
    transform: "translate(-12.537 -7.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78561",
    "data-name": "Path 78561",
    className: "cls-11",
    d: "M82.815,47.483l-.233.278-6.666-4.075-5.468-3.343,5.141,2.968Z",
    transform: "translate(-14.027 -8.033)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78562",
    "data-name": "Path 78562",
    className: "cls-7",
    d: "M53.2,37.853c0,1.294-.914,1.815-2.041,1.164a4.5,4.5,0,0,1-2.042-3.521c0-1.294.915-1.815,2.042-1.164A4.5,4.5,0,0,1,53.2,37.853",
    transform: "translate(-9.779 -6.78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78563",
    "data-name": "Path 78563",
    className: "cls-8",
    d: "M53.052,37.476c0,1.1-.78,1.55-1.743.994a3.842,3.842,0,0,1-1.744-3.007c0-1.1.781-1.55,1.744-.994a3.841,3.841,0,0,1,1.743,3.007",
    transform: "translate(-9.869 -6.816)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78564",
    "data-name": "Path 78564",
    className: "cls-7",
    d: "M59.745,41.868c0,1.294-.914,1.816-2.041,1.164a4.5,4.5,0,0,1-2.042-3.522c0-1.293.915-1.815,2.042-1.164a4.5,4.5,0,0,1,2.041,3.522",
    transform: "translate(-11.083 -7.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78565",
    "data-name": "Path 78565",
    className: "cls-8",
    d: "M59.6,41.491c0,1.1-.78,1.55-1.743.994a3.842,3.842,0,0,1-1.744-3.007c0-1.1.781-1.55,1.744-.994A3.841,3.841,0,0,1,59.6,41.491",
    transform: "translate(-11.172 -7.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78566",
    "data-name": "Path 78566",
    className: "cls-7",
    d: "M92.037,59.718c0,1.294-.914,1.815-2.041,1.164a4.5,4.5,0,0,1-2.042-3.522c0-1.293.915-1.815,2.042-1.164a4.5,4.5,0,0,1,2.041,3.522",
    transform: "translate(-17.512 -11.133)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78567",
    "data-name": "Path 78567",
    className: "cls-8",
    d: "M91.89,59.341c0,1.1-.78,1.55-1.743.994A3.842,3.842,0,0,1,88.4,57.328c0-1.1.781-1.55,1.744-.994a3.841,3.841,0,0,1,1.743,3.007",
    transform: "translate(-17.602 -11.169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78568",
    "data-name": "Path 78568",
    className: "cls-7",
    d: "M98.583,63.733c0,1.294-.914,1.815-2.041,1.164A4.5,4.5,0,0,1,94.5,61.375c0-1.293.915-1.815,2.042-1.164a4.5,4.5,0,0,1,2.041,3.522",
    transform: "translate(-18.816 -11.933)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78569",
    "data-name": "Path 78569",
    className: "cls-8",
    d: "M98.435,63.356c0,1.1-.78,1.55-1.743.994a3.842,3.842,0,0,1-1.744-3.007c0-1.1.781-1.55,1.744-.994a3.841,3.841,0,0,1,1.743,3.007",
    transform: "translate(-18.905 -11.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78570",
    "data-name": "Path 78570",
    className: "cls-9",
    d: "M62.773,37.194l-.2.184-.124.115-.049.046-2.027,1.869-1.322.7v0h0l-3.885-4.455h0l-1.314-1.5-1.236-1.418-1.744-2h0l-.835-.958.135-.626,2.817,1.239,7.373,4.258,2.023,2.145Z",
    transform: "translate(-9.962 -5.802)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78571",
    "data-name": "Path 78571",
    className: "cls-12",
    d: "M62.919,36.674l-.757.577-.211-.162L59.288,35.06l-.032.038-.529.628-.143.171-.758.577-5.712-4.155-3.275-2.383-.095-.333-.339-1.2-.876-1.294,4.957,2.861,7.373,4.258.031.018,1.61.928,1.152.666Z",
    transform: "translate(-9.464 -5.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78572",
    "data-name": "Path 78572",
    className: "cls-10",
    d: "M61.29,37.182l-.579.7-1.99,2.4L49.153,34.75,48.6,31.81l-.22-1.178L48.519,30l8.555,3.768Z",
    transform: "translate(-9.633 -5.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78573",
    "data-name": "Path 78573",
    className: "cls-11",
    d: "M61.29,37.182l-.579.7-1.591-.7-.1.111-.606.723-9.747-5.958L48.6,31.81l-.22-1.178L48.519,30l8.555,3.768Z",
    transform: "translate(-9.633 -5.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78574",
    "data-name": "Path 78574",
    className: "cls-13",
    d: "M61.763,37.086,61.5,36.97l-.892-.4L58.328,35.56l-.2-.087-.093.11-.612.726L52.95,33.571,47.926,30.5l-.243-.149-.432-1.53-1.728-1.294.457-1.241,1.152.664,4.956,2.862,7.373,4.258.032.018,1.609.928.382,1.2.192.6Z",
    transform: "translate(-9.064 -5.233)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78575",
    "data-name": "Path 78575",
    className: "cls-14",
    d: "M101.567,59.8l-.2.185-.125.115-.05.045-2.025,1.87-1.322.7,0,0v0l-3.886-4.456h0l-1.313-1.5-1.237-1.42-1.744-2-.835-.958.135-.626,4.048,1.78L98.8,56.871l2.372,2.515Z",
    transform: "translate(-17.686 -10.303)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78576",
    "data-name": "Path 78576",
    className: "cls-12",
    d: "M101.666,59.215l-.757.577-.213-.162L98.033,57.6,98,57.638l-.528.629-.143.171-.758.577L90.86,54.857l-3.273-2.382-.094-.332-.339-1.2-1.064-1.571,2.584,1.492,1.106.639,2.685,1.55L98.257,56.4l1.508.871q.213.123.422.259a10.7,10.7,0,0,1,1.243.946Z",
    transform: "translate(-17.141 -9.831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78577",
    "data-name": "Path 78577",
    className: "cls-15",
    d: "M100.084,59.791l-.579.7-1.99,2.4L87.947,57.36,87.4,54.419l-.22-1.178.138-.626,8.554,3.767Z",
    transform: "translate(-17.358 -10.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78578",
    "data-name": "Path 78578",
    className: "cls-16",
    d: "M100.084,59.791l-.579.7-1.591-.7-.1.111-.605.723L87.465,54.66l-.069-.241-.22-1.178.138-.626,8.554,3.767Z",
    transform: "translate(-17.358 -10.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78579",
    "data-name": "Path 78579",
    className: "cls-13",
    d: "M100.557,59.661l-.263-.116-.891-.4-2.282-1.014-.2-.088-.092.111-.612.726-4.475-2.737L86.72,53.072l-.243-.149-.433-1.53L84.316,50.1l.509-1.382.75.434.161.092,2.584,1.492,1.106.639,2.685,1.55L97.9,56.268l1.508.871c.141.082.282.167.421.259l.443,1.385.192.6Z",
    transform: "translate(-16.788 -9.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78580",
    "data-name": "Path 78580",
    className: "cls-3",
    d: "M108.144,67.165c0,1.68-1.188,2.357-2.653,1.512A5.847,5.847,0,0,1,102.84,64.1c0-1.68,1.189-2.357,2.652-1.512a5.844,5.844,0,0,1,2.653,4.574",
    transform: "translate(-20.477 -12.39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78581",
    "data-name": "Path 78581",
    className: "cls-3",
    d: "M107.549,65.45l-1.324.576a4.657,4.657,0,0,1,.56,2.331c-.037,1.346-.268,1.246-.268,1.246l-1.373.474-3.422-6.611,1.823-1.112,2.107,1.124Z",
    transform: "translate(-20.254 -12.415)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78582",
    "data-name": "Path 78582",
    className: "cls-7",
    d: "M105.99,68.5c0,1.68-1.187,2.357-2.652,1.511a5.842,5.842,0,0,1-2.652-4.573c0-1.68,1.188-2.357,2.652-1.512A5.843,5.843,0,0,1,105.99,68.5",
    transform: "translate(-20.048 -12.656)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78583",
    "data-name": "Path 78583",
    className: "cls-8",
    d: "M105.451,68.313c0,1.225-.866,1.719-1.933,1.1a4.259,4.259,0,0,1-1.933-3.334c0-1.225.865-1.719,1.933-1.1a4.258,4.258,0,0,1,1.933,3.334",
    transform: "translate(-20.227 -12.885)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78584",
    "data-name": "Path 78584",
    className: "cls-3",
    d: "M64.411,63.383,16.217,35.558c-2.011-1.16-3.826-1.362-5.119-.75v0l-.027.016a3.111,3.111,0,0,0-.4.227L2.035,40.03l.923.869,3.131,3.533c.17,3.925,5.215,3.966,9.035,6.172L58.79,75.813l2.15,7.7,8.707-5.027c.074-.039.147-.082.219-.127l.026-.015-1.092.63c1.02-.658,2.725-2.536,2.725-4.282,0-3.98-3.184-9.046-7.113-11.314",
    transform: "translate(-0.405 -6.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78585",
    "data-name": "Path 78585",
    className: "cls-4",
    d: "M11.206,36.865l6.356-1.241a10.079,10.079,0,0,0-.789-.792l-6.06,1.226L7.671,40.243l.442.838Z",
    transform: "translate(-1.527 -6.935)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78586",
    "data-name": "Path 78586",
    className: "cls-4",
    d: "M16.153,39.681l6.356-1.241a10.078,10.078,0,0,0-.789-.792l-6.06,1.226-3.042,4.185.441.838Z",
    transform: "translate(-2.512 -7.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78587",
    "data-name": "Path 78587",
    className: "cls-4",
    d: "M21.1,42.5l6.356-1.241a9.937,9.937,0,0,0-.789-.792l-6.06,1.226-3.041,4.185.44.838Z",
    transform: "translate(-3.498 -8.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78588",
    "data-name": "Path 78588",
    className: "cls-4",
    d: "M26.048,45.311,32.4,44.07a9.8,9.8,0,0,0-.789-.792L25.554,44.5l-3.04,4.185.44.838Z",
    transform: "translate(-4.483 -8.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78589",
    "data-name": "Path 78589",
    className: "cls-4",
    d: "M31,48.126l6.356-1.241a9.936,9.936,0,0,0-.789-.792L30.5,47.319,27.461,51.5l.441.838Z",
    transform: "translate(-5.468 -9.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78590",
    "data-name": "Path 78590",
    className: "cls-4",
    d: "M35.942,50.941,42.3,49.7a10.077,10.077,0,0,0-.789-.792l-6.06,1.226-3.042,4.185.441.838Z",
    transform: "translate(-6.453 -9.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78591",
    "data-name": "Path 78591",
    className: "cls-4",
    d: "M40.89,53.757l6.355-1.241a10.18,10.18,0,0,0-.788-.792L40.4,52.95l-3.043,4.185.441.838Z",
    transform: "translate(-7.438 -10.299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78592",
    "data-name": "Path 78592",
    className: "cls-4",
    d: "M45.837,56.572l6.356-1.241a9.936,9.936,0,0,0-.789-.792l-6.06,1.226L42.3,59.95l.44.838Z",
    transform: "translate(-8.423 -10.859)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78593",
    "data-name": "Path 78593",
    className: "cls-4",
    d: "M50.784,59.387l6.356-1.241a9.938,9.938,0,0,0-.789-.792l-6.06,1.226L47.25,62.765l.44.838Z",
    transform: "translate(-9.408 -11.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78594",
    "data-name": "Path 78594",
    className: "cls-4",
    d: "M55.731,62.2l6.356-1.241a9.94,9.94,0,0,0-.789-.792L55.238,61.4,52.2,65.58l.44.838Z",
    transform: "translate(-10.393 -11.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78595",
    "data-name": "Path 78595",
    className: "cls-4",
    d: "M60.679,65.018l6.356-1.241a10.082,10.082,0,0,0-.789-.792l-6.06,1.226L57.144,68.4l.441.838Z",
    transform: "translate(-11.378 -12.541)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78596",
    "data-name": "Path 78596",
    className: "cls-4",
    d: "M65.626,67.833l6.356-1.241a10.077,10.077,0,0,0-.789-.792l-6.06,1.226-3.042,4.185.442.838Z",
    transform: "translate(-12.363 -13.102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78597",
    "data-name": "Path 78597",
    className: "cls-4",
    d: "M70.573,70.648l6.356-1.241a9.937,9.937,0,0,0-.789-.792l-6.06,1.226-3.041,4.185.44.838Z",
    transform: "translate(-13.348 -13.662)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78598",
    "data-name": "Path 78598",
    className: "cls-4",
    d: "M75.453,73.54,81.809,72.3a9.935,9.935,0,0,0-.789-.792l-6.06,1.226-3.041,4.185.441.838Z",
    transform: "translate(-14.32 -14.238)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78599",
    "data-name": "Path 78599",
    className: "cls-4",
    d: "M78.882,78.084l6.356-1.241a9.939,9.939,0,0,0-.789-.792l-6.06,1.226-3.041,4.185.44.838Z",
    transform: "translate(-15.003 -15.143)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78600",
    "data-name": "Path 78600",
    className: "cls-4",
    d: "M80.48,83.253l6.356-1.241a10.08,10.08,0,0,0-.789-.792l-6.06,1.226-3.042,4.185.441.838Z",
    transform: "translate(-15.321 -16.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78601",
    "data-name": "Path 78601",
    className: "cls-4",
    d: "M80.55,88.945,86.906,87.7a9.939,9.939,0,0,0-.789-.792l-6.06,1.226-3.041,4.185.44.838Z",
    transform: "translate(-15.335 -17.305)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78602",
    "data-name": "Path 78602",
    className: "cls-5",
    d: "M7.113,41.827,55.308,69.652c3.929,2.268,7.114,7.334,7.114,11.314s-3.185,5.368-7.114,3.1L7.113,56.242C3.184,53.973,0,48.907,0,44.927s3.184-5.368,7.113-3.1",
    transform: "translate(0 -8.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78603",
    "data-name": "Path 78603",
    className: "cls-3",
    d: "M61.33,80.591a4.611,4.611,0,0,1-.1.98c-.5,2.272-2.8,2.884-5.561,1.291L7.475,55.037c-3.12-1.8-5.66-5.752-5.66-8.807,0-2.642,1.9-3.76,4.436-2.846a7.684,7.684,0,0,1,1.224.575L55.669,71.785c3.122,1.8,5.661,5.753,5.661,8.806",
    transform: "translate(-0.361 -8.576)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78604",
    "data-name": "Path 78604",
    className: "cls-6",
    d: "M62.408,80.669a4.612,4.612,0,0,1-.1.98,7.594,7.594,0,0,1-1.224-.577L12.891,53.248C9.769,51.447,7.23,47.5,7.23,44.442a4.609,4.609,0,0,1,.1-.979,7.682,7.682,0,0,1,1.224.575l2.485,1.435,1.152.665L17.146,49l7.373,4.258.032.018,1.609.928,1.153.666,3.231,1.866L35.685,59.7,42.16,63.44l.751.435.16.092,2.584,1.492,1.106.639,2.685,1.55,5.793,3.344,1.508.871c.142.082.283.167.422.259a10.614,10.614,0,0,1,1.243.947c2.311,2.032,4,5.114,4,7.6",
    transform: "translate(-1.44 -8.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78605",
    "data-name": "Path 78605",
    className: "cls-7",
    d: "M41.554,70.547c0,1.294-.914,1.815-2.041,1.164a4.5,4.5,0,0,1-2.042-3.522c0-1.293.915-1.815,2.042-1.164a4.5,4.5,0,0,1,2.041,3.522",
    transform: "translate(-7.461 -13.29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78606",
    "data-name": "Path 78606",
    className: "cls-8",
    d: "M41.406,70.17c0,1.1-.78,1.55-1.743.994a3.842,3.842,0,0,1-1.744-3.007c0-1.1.781-1.55,1.744-.994a3.841,3.841,0,0,1,1.743,3.007",
    transform: "translate(-7.55 -13.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78607",
    "data-name": "Path 78607",
    className: "cls-3",
    d: "M13.69,51.552c0,1.68-1.187,2.357-2.652,1.512a5.845,5.845,0,0,1-2.652-4.574c0-1.68,1.188-2.357,2.652-1.512a5.843,5.843,0,0,1,2.652,4.574",
    transform: "translate(-1.67 -9.282)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78608",
    "data-name": "Path 78608",
    className: "cls-3",
    d: "M13.1,49.837l-1.324.576a4.657,4.657,0,0,1,.56,2.331c-.037,1.346-.268,1.246-.268,1.246l-1.373.474L7.268,47.853l1.823-1.112L11.2,47.865Z",
    transform: "translate(-1.447 -9.307)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78609",
    "data-name": "Path 78609",
    className: "cls-7",
    d: "M11.536,52.886c0,1.68-1.187,2.357-2.652,1.512a5.845,5.845,0,0,1-2.652-4.574c0-1.68,1.188-2.357,2.652-1.512a5.843,5.843,0,0,1,2.652,4.574",
    transform: "translate(-1.241 -9.547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78610",
    "data-name": "Path 78610",
    className: "cls-8",
    d: "M11,52.7c0,1.225-.866,1.719-1.933,1.1a4.257,4.257,0,0,1-1.933-3.334c0-1.225.865-1.719,1.933-1.1A4.258,4.258,0,0,1,11,52.7",
    transform: "translate(-1.42 -9.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78611",
    "data-name": "Path 78611",
    className: "cls-3",
    d: "M53.278,73.979c0,1.68-1.187,2.357-2.652,1.512a5.845,5.845,0,0,1-2.652-4.574c0-1.68,1.188-2.357,2.652-1.512a5.843,5.843,0,0,1,2.652,4.574",
    transform: "translate(-9.552 -13.747)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78612",
    "data-name": "Path 78612",
    className: "cls-3",
    d: "M52.683,72.264l-1.324.576a4.657,4.657,0,0,1,.56,2.331c-.037,1.346-.268,1.246-.268,1.246l-1.373.474L46.856,70.28l1.823-1.112,2.106,1.124Z",
    transform: "translate(-9.33 -13.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78613",
    "data-name": "Path 78613",
    className: "cls-7",
    d: "M51.125,75.312c0,1.68-1.187,2.357-2.652,1.512a5.845,5.845,0,0,1-2.652-4.574c0-1.68,1.188-2.357,2.652-1.512a5.843,5.843,0,0,1,2.652,4.574",
    transform: "translate(-9.124 -14.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78614",
    "data-name": "Path 78614",
    className: "cls-8",
    d: "M50.585,75.127c0,1.225-.866,1.719-1.933,1.1a4.258,4.258,0,0,1-1.933-3.334c0-1.225.865-1.719,1.933-1.1a4.258,4.258,0,0,1,1.933,3.334",
    transform: "translate(-9.302 -14.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78615",
    "data-name": "Path 78615",
    className: "cls-3",
    d: "M35.262,63.707c0,1.68-1.187,2.357-2.652,1.512a5.845,5.845,0,0,1-2.652-4.574c0-1.68,1.188-2.357,2.652-1.512a5.843,5.843,0,0,1,2.652,4.574",
    transform: "translate(-5.965 -11.702)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78616",
    "data-name": "Path 78616",
    className: "cls-3",
    d: "M34.668,61.992l-1.324.576A4.657,4.657,0,0,1,33.9,64.9c-.037,1.346-.268,1.246-.268,1.246l-1.373.474-3.422-6.611L30.664,58.9l2.107,1.124Z",
    transform: "translate(-5.743 -11.727)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78617",
    "data-name": "Path 78617",
    className: "cls-7",
    d: "M33.109,65.04c0,1.68-1.187,2.357-2.652,1.512a5.845,5.845,0,0,1-2.652-4.574c0-1.68,1.188-2.357,2.652-1.512a5.843,5.843,0,0,1,2.652,4.574",
    transform: "translate(-5.536 -11.967)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78618",
    "data-name": "Path 78618",
    className: "cls-8",
    d: "M32.57,64.855c0,1.225-.866,1.719-1.933,1.1A4.257,4.257,0,0,1,28.7,62.623c0-1.225.865-1.719,1.933-1.1a4.258,4.258,0,0,1,1.933,3.334",
    transform: "translate(-5.715 -12.197)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78619",
    "data-name": "Path 78619",
    className: "cls-14",
    d: "M53.836,70.136l-1.06.977-2.459,1.294,0,0h0l-7.228-8.288-.328-.375,7.226,4.172L52.73,69.5Z",
    transform: "translate(-8.514 -12.692)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78620",
    "data-name": "Path 78620",
    className: "cls-15",
    d: "M49.962,67.9l-2.414,2.907h0L29.759,60.535l-.9-4.821,5.993,3.461,5.141,2.968,7.226,4.172Z",
    transform: "translate(-5.746 -11.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78621",
    "data-name": "Path 78621",
    className: "cls-16",
    d: "M48.708,67.175l-.233.278-6.666-4.075L36.34,60.035,41.482,63Z",
    transform: "translate(-7.236 -11.954)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78622",
    "data-name": "Path 78622",
    className: "cls-7",
    d: "M19.092,57.544c0,1.294-.914,1.815-2.041,1.164a4.5,4.5,0,0,1-2.042-3.522c0-1.293.915-1.815,2.042-1.164a4.5,4.5,0,0,1,2.041,3.522",
    transform: "translate(-2.988 -10.701)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78623",
    "data-name": "Path 78623",
    className: "cls-8",
    d: "M18.945,57.167c0,1.1-.78,1.55-1.743.994a3.842,3.842,0,0,1-1.744-3.007c0-1.1.781-1.55,1.744-.994a3.841,3.841,0,0,1,1.743,3.007",
    transform: "translate(-3.078 -10.736)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78624",
    "data-name": "Path 78624",
    className: "cls-7",
    d: "M25.638,61.559c0,1.294-.914,1.815-2.041,1.164A4.5,4.5,0,0,1,21.554,59.2c0-1.293.915-1.815,2.042-1.164a4.5,4.5,0,0,1,2.041,3.522",
    transform: "translate(-4.292 -11.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78625",
    "data-name": "Path 78625",
    className: "cls-8",
    d: "M25.49,61.182c0,1.1-.78,1.55-1.743.994A3.842,3.842,0,0,1,22,59.169c0-1.1.781-1.55,1.744-.994a3.841,3.841,0,0,1,1.743,3.007",
    transform: "translate(-4.381 -11.536)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78626",
    "data-name": "Path 78626",
    className: "cls-7",
    d: "M57.93,79.409c0,1.294-.914,1.815-2.041,1.164a4.5,4.5,0,0,1-2.042-3.522c0-1.293.915-1.815,2.042-1.164a4.5,4.5,0,0,1,2.041,3.522",
    transform: "translate(-10.721 -15.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78627",
    "data-name": "Path 78627",
    className: "cls-8",
    d: "M57.783,79.032c0,1.1-.78,1.55-1.743.994A3.842,3.842,0,0,1,54.3,77.019c0-1.1.781-1.55,1.744-.994a3.841,3.841,0,0,1,1.743,3.007",
    transform: "translate(-10.811 -15.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78628",
    "data-name": "Path 78628",
    className: "cls-7",
    d: "M64.476,83.424c0,1.294-.914,1.816-2.041,1.164a4.5,4.5,0,0,1-2.042-3.522c0-1.293.915-1.815,2.042-1.164a4.5,4.5,0,0,1,2.041,3.522",
    transform: "translate(-12.025 -15.854)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78629",
    "data-name": "Path 78629",
    className: "cls-8",
    d: "M64.328,83.047c0,1.1-.78,1.55-1.743.994a3.842,3.842,0,0,1-1.744-3.007c0-1.1.781-1.55,1.744-.994a3.841,3.841,0,0,1,1.743,3.007",
    transform: "translate(-12.114 -15.889)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78630",
    "data-name": "Path 78630",
    className: "cls-14",
    d: "M28.666,56.886l-.2.184-.124.115-.049.046L26.266,59.1l-1.322.7v0h0l-3.885-4.455h0l-1.314-1.5-1.236-1.418-1.744-2h0l-.835-.958.135-.626,2.817,1.239,7.373,4.258,2.023,2.145Z",
    transform: "translate(-3.171 -9.722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78631",
    "data-name": "Path 78631",
    className: "cls-12",
    d: "M28.812,56.366l-.757.577-.211-.161-2.663-2.029-.032.038-.529.628-.143.171-.758.577-5.712-4.155-3.275-2.383-.095-.333L14.3,48.1,13.423,46.8l4.957,2.861,7.373,4.258.031.018,1.61.928,1.153.666Z",
    transform: "translate(-2.673 -9.319)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78632",
    "data-name": "Path 78632",
    className: "cls-17",
    d: "M27.183,56.874l-.579.7-1.99,2.4-9.567-5.524L14.495,51.5l-.22-1.178.138-.627,8.554,3.768Z",
    transform: "translate(-2.842 -9.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78633",
    "data-name": "Path 78633",
    className: "cls-16",
    d: "M27.183,56.874l-.579.7-1.591-.7-.1.111-.605.723-9.747-5.958-.069-.241-.22-1.178.138-.627,8.554,3.768Z",
    transform: "translate(-2.842 -9.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78634",
    "data-name": "Path 78634",
    className: "cls-13",
    d: "M27.656,56.778l-.261-.116-.892-.4-2.282-1.014-.2-.087-.093.11L23.319,56l-4.475-2.737-5.025-3.074-.243-.149-.432-1.53-1.728-1.294.457-1.241,1.152.664L17.979,49.5l7.373,4.258.032.018,1.609.928.382,1.2.192.6Z",
    transform: "translate(-2.273 -9.154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78635",
    "data-name": "Path 78635",
    className: "cls-14",
    d: "M67.46,79.494l-.2.184-.125.116-.05.045-2.025,1.87-1.322.7v0l0,0L59.85,77.945h0l-1.313-1.5L57.3,75.021l-1.744-2-.835-.958.135-.626,4.048,1.78L64.7,76.563l2.372,2.515Z",
    transform: "translate(-10.895 -14.224)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78636",
    "data-name": "Path 78636",
    className: "cls-12",
    d: "M67.559,78.907l-.757.577-.213-.162-2.663-2.029-.031.037-.528.629-.143.171-.758.577-5.714-4.157L53.48,72.167l-.095-.332-.339-1.2-1.064-1.571,2.584,1.492,1.106.638,2.685,1.55,5.793,3.344,1.508.871q.213.123.422.26a10.691,10.691,0,0,1,1.243.946Z",
    transform: "translate(-10.35 -13.752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78637",
    "data-name": "Path 78637",
    className: "cls-17",
    d: "M65.977,79.483l-.578.7-1.991,2.4L53.84,77.051l-.551-2.941-.22-1.178.138-.627,8.555,3.768Z",
    transform: "translate(-10.567 -14.397)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78638",
    "data-name": "Path 78638",
    className: "cls-16",
    d: "M65.977,79.483l-.578.7-1.591-.7-.1.111-.606.723-9.747-5.958-.069-.241-.22-1.178.138-.627,8.555,3.768Z",
    transform: "translate(-10.567 -14.397)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78639",
    "data-name": "Path 78639",
    className: "cls-13",
    d: "M66.45,79.352l-.262-.116-.891-.4-2.282-1.014-.2-.088-.093.111-.612.726-4.475-2.737-5.025-3.074-.243-.149-.433-1.531-1.728-1.294.509-1.382.75.435.161.092,2.584,1.492,1.106.639L58,72.615,63.8,75.959l1.508.871c.142.082.282.167.421.259l.443,1.385.192.6Z",
    transform: "translate(-9.997 -13.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78640",
    "data-name": "Path 78640",
    className: "cls-3",
    d: "M74.036,86.857c0,1.68-1.187,2.357-2.652,1.512A5.845,5.845,0,0,1,68.733,83.8c0-1.68,1.188-2.357,2.652-1.512a5.843,5.843,0,0,1,2.652,4.574",
    transform: "translate(-13.686 -16.311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78641",
    "data-name": "Path 78641",
    className: "cls-3",
    d: "M73.442,85.141l-1.324.576a4.647,4.647,0,0,1,.56,2.331c-.037,1.346-.268,1.246-.268,1.246l-1.373.474-3.422-6.611,1.823-1.112,2.107,1.124Z",
    transform: "translate(-13.463 -16.336)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78642",
    "data-name": "Path 78642",
    className: "cls-7",
    d: "M71.883,88.19c0,1.68-1.187,2.357-2.652,1.512a5.845,5.845,0,0,1-2.652-4.574c0-1.68,1.188-2.357,2.652-1.512a5.843,5.843,0,0,1,2.652,4.574",
    transform: "translate(-13.257 -16.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78643",
    "data-name": "Path 78643",
    className: "cls-8",
    d: "M71.344,88.005c0,1.225-.866,1.719-1.933,1.1a4.258,4.258,0,0,1-1.933-3.334c0-1.225.865-1.719,1.933-1.1a4.258,4.258,0,0,1,1.933,3.334",
    transform: "translate(-13.436 -16.806)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78644",
    "data-name": "Path 78644",
    className: "cls-6",
    d: "M66.845,64.179,61.1,67.5,43.935,56.788a34.372,34.372,0,0,1-9.454-2.432c-5.761-2.229-6.733-6.451-6.733-6.451L8.819,36.985l3.6-2.076L68.757,48.466,64.723,62.846Z",
    transform: "translate(-1.756 -6.951)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78645",
    "data-name": "Path 78645",
    className: "cls-18",
    d: "M30.772,43.522H73v1.221h-.038c.213,3.282-1.836,6.612-6.192,9.126-8.271,4.777-21.641,4.8-29.863.054-4.36-2.518-6.37-5.871-6.085-9.18h-.052Z",
    transform: "translate(-6.127 -8.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78646",
    "data-name": "Path 78646",
    className: "cls-19",
    d: "M36.91,49.137c8.222,4.745,21.591,4.723,29.863-.054s8.312-12.495.093-17.24-21.589-4.722-29.86.054-8.315,12.495-.1,17.239",
    transform: "translate(-6.127 -5.635)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78647",
    "data-name": "Path 78647",
    className: "cls-20",
    d: "M161.608,33.5l-3.775-2.863-5.68-2.156v6.136l4.885,1.374L162,35.5Z",
    transform: "translate(-30.295 -5.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78648",
    "data-name": "Path 78648",
    className: "cls-21",
    d: "M157.833,30.509l.889-.513-5.68-2.156-.889.513Z",
    transform: "translate(-30.295 -5.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78649",
    "data-name": "Path 78649",
    className: "cls-21",
    d: "M151.308,28.352l.889-.513-4.288,0,1.8.708Z",
    transform: "translate(-29.45 -5.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78650",
    "data-name": "Path 78650",
    className: "cls-22",
    d: "M151.755,34.617V28.48l-1.6.193V34.81Z",
    transform: "translate(-29.897 -5.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78651",
    "data-name": "Path 78651",
    className: "cls-23",
    d: "M163.02,33.908l.889-.513-3.775-2.863-.89.513Z",
    transform: "translate(-31.707 -6.079)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78652",
    "data-name": "Path 78652",
    className: "cls-24",
    d: "M163.958,34.62l.889-.513.4,2-.889.513Z",
    transform: "translate(-32.646 -6.791)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78653",
    "data-name": "Path 78653",
    className: "cls-25",
    d: "M89.24,27.618l6.955-11.01,3.228-1.863,6.953-1.8,34.67,13.861,3.775,2.863.4,2-3.227,1.863-31.01-9.6-7.189.979-9.735,6.519-1.689,4.611L89.142,37.9Z",
    transform: "translate(-17.749 -2.578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78654",
    "data-name": "Path 78654",
    className: "cls-26",
    d: "M109.858,12.946l-3.227,1.863L138.26,27.444l3.227-1.864Z",
    transform: "translate(-21.232 -2.578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78655",
    "data-name": "Path 78655",
    className: "cls-27",
    d: "M137.123,26.456l-4.756-1.98H131.7L117.572,18.5l-.413-.722.907-.44,15.454,6.514.035.413,4.266,1.832Z",
    transform: "translate(-23.328 -3.453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78656",
    "data-name": "Path 78656",
    className: "cls-6",
    d: "M90.446,23.553l-.493-.392,5.284-6.594c.239-.114,5.862-2.816,7.928-2.476,2,.319,9.647,3.083,9.971,3.2l-.215.591c-.079-.028-7.911-2.862-9.855-3.172-1.531-.245-5.864,1.614-7.492,2.391Z",
    transform: "translate(-17.911 -2.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78657",
    "data-name": "Path 78657",
    className: "cls-6",
    d: "M92.262,22.285l-.493-.392L97.053,15.3c.238-.114,5.862-2.818,7.928-2.476,2.015.32,9.138,3.562,9.441,3.7l-.261.572c-.074-.033-7.347-3.344-9.278-3.651-1.544-.245-5.865,1.615-7.492,2.391Z",
    transform: "translate(-18.272 -2.548)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78658",
    "data-name": "Path 78658",
    className: "cls-25",
    d: "M150.665,23.707l3.227-1.863,1.9-.058,5.44,7.5,10.505,42.478-3.228,1.864Z",
    transform: "translate(-29.999 -4.338)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78659",
    "data-name": "Path 78659",
    className: "cls-27",
    d: "M163.414,34.3s-.3-.82-.585-.821-1.048.269-1.048.72,6.032,25.634,6.032,25.634l.763.335,3.108,12.882.5-.185-2.826-12.7a12.608,12.608,0,0,0-.1-1.328c-.083-.513-5.846-24.54-5.846-24.54",
    transform: "translate(-32.213 -6.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78660",
    "data-name": "Path 78660",
    className: "cls-22",
    d: "M118.381,18.2a.561.561,0,0,0,.308.341c.171.06,17.074,3.228,17.074,3.228l.295-2.06s-16.819-3.159-16.947-3.2a.488.488,0,0,0-.525.231,1.628,1.628,0,0,0-.205,1.458",
    transform: "translate(-23.553 -3.285)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78661",
    "data-name": "Path 78661",
    className: "cls-24",
    d: "M139.6,22.213c.176.434.553.484.843.112a1.628,1.628,0,0,0,.205-1.458.449.449,0,0,0-.843-.112,1.628,1.628,0,0,0-.205,1.458",
    transform: "translate(-27.779 -4.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78662",
    "data-name": "Path 78662",
    className: "cls-28",
    d: "M152.072,24.443l.062-1.073-11.6-2.217a.538.538,0,0,0-.637.5.527.527,0,0,0,.428.549Z",
    transform: "translate(-27.855 -4.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78663",
    "data-name": "Path 78663",
    className: "cls-29",
    d: "M150.153,32.1l.41-7.928,1.9-.058,5.439,7.5,10.505,42.478-1.974.279Z",
    transform: "translate(-29.897 -4.801)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78664",
    "data-name": "Path 78664",
    className: "cls-27",
    d: "M157.162,38.773l-1.438,1.432-1.291.944-1.3.263-2.978-7.733.084-1.63,3.42,1.394,2.616,2.277Z",
    transform: "translate(-29.897 -6.381)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78665",
    "data-name": "Path 78665",
    className: "cls-17",
    d: "M84.778,29.944,94.96,17.072l6.953-1.8,31.629,12.634-.013,5.946-27.011-7.6-7.189.979L89.6,33.752l-1.689,4.611L82.94,34.07Z",
    transform: "translate(-16.514 -3.041)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78666",
    "data-name": "Path 78666",
    className: "cls-17",
    d: "M154.947,37.345l-3.775-2.863-5.681-2.156v6.136l4.885,1.374,4.967-.495Z",
    transform: "translate(-28.969 -6.437)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78667",
    "data-name": "Path 78667",
    className: "cls-21",
    d: "M151.172,34.354l.889-.513-5.68-2.156-.889.513Z",
    transform: "translate(-28.969 -6.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78668",
    "data-name": "Path 78668",
    className: "cls-21",
    d: "M145.176,31.765l.889-.513-1.27-1.744-.889.513Z",
    transform: "translate(-28.653 -5.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78669",
    "data-name": "Path 78669",
    className: "cls-22",
    d: "M145.176,38.029V31.892l-1.27-1.744v6.136Z",
    transform: "translate(-28.653 -6.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78670",
    "data-name": "Path 78670",
    className: "cls-30",
    d: "M156.359,37.754l.889-.513-3.775-2.863-.889.513Z",
    transform: "translate(-30.381 -6.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78671",
    "data-name": "Path 78671",
    className: "cls-25",
    d: "M157.3,38.465l.889-.513.4,2-.889.513Z",
    transform: "translate(-31.32 -7.557)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72772",
    "data-name": "Group 72772",
    className: "cls-31",
    transform: "translate(82.405 15.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72771",
    "data-name": "Group 72771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72770",
    "data-name": "Group 72770",
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78672",
    "data-name": "Path 78672",
    className: "cls-33",
    d: "M107.089,19.77l-3.127,8.18-.658.09-.412.276,1.652-5.2,1.695-3.785Z",
    transform: "translate(-102.892 -19.329)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_78673",
    "data-name": "Path 78673",
    className: "cls-34",
    d: "M175.965,83.971l2,.46,1.346,2,2.135,11.14s-.511,2.634-.511,3.06-12.041,7.073-12.041,7.073l1.04-12.04L157.908,83.2l5.942,3.574,4.576.27Z",
    transform: "translate(-31.441 -16.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78674",
    "data-name": "Path 78674",
    className: "cls-35",
    d: "M170.6,84.961l-11.815,6.82L153.67,93.87l-4.575-.27-5.941-3.574.52-.3,3.68,2.214,10.778-6.223L154.451,83.5l.519-.3,5.942,3.574,4.576.271Z",
    transform: "translate(-28.504 -16.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78675",
    "data-name": "Path 78675",
    className: "cls-36",
    d: "M146.267,89.849h0l-.52.3Z",
    transform: "translate(-29.02 -17.89)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78676",
    "data-name": "Path 78676",
    className: "cls-36",
    d: "M166.116,88.174l-2.08,1.2-2.235,1.29-.144.084h0l-1.414.816-.521.3-.12.07-.443.181-2.081.85-.036.014-1.125.46-1.289.525-.31-.018-3.93-.233-.088,0-1.9-1.144,10.778-6.223,2.261,1.359.359.216Z",
    transform: "translate(-29.548 -17.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78677",
    "data-name": "Path 78677",
    className: "cls-18",
    d: "M165.286,89.122,162.9,90.5h0l-1.414.816-.519.3h0l-1.258-1.3-5.046-5.231,1.925,1.157,0,0,4.015,2.415.359.216,4.318.256Z",
    transform: "translate(-30.796 -16.94)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78678",
    "data-name": "Path 78678",
    className: "cls-18",
    d: "M162.311,90.838l-1.414.816-.519.3h0l-.12.07-.443.181-2.081.85-1-1.032-5.045-5.231,1.925,1.157v0l4.016,2.415.359.216,1.126.067Z",
    transform: "translate(-30.204 -17.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78679",
    "data-name": "Path 78679",
    className: "cls-18",
    d: "M159.222,92.546l-2.081.85-.035.015-1.126.459-1.289.526-.309-.018-5.662-5.871,1.925,1.157,0,0,4.015,2.415.359.215,1.125.067Z",
    transform: "translate(-29.612 -17.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78680",
    "data-name": "Path 78680",
    className: "cls-18",
    d: "M155.388,94.212l-1.289.525-4.24-.251-4.112-4.263,1.925,1.157v0L151.69,93.8l.359.216Z",
    transform: "translate(-29.02 -17.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78681",
    "data-name": "Path 78681",
    className: "cls-37",
    d: "M165.588,87.847l-4.32-.256-.359-.216-2.261-1.359-1.559.9L153.41,84.7l-.52.3,1.925,1.157h0l1.754,1.056-1.861,1.075-3.68-2.214-.519.3,1.925,1.157h0l1.754,1.056-1.861,1.075-3.68-2.214-.52.3,1.925,1.157h0l1.755,1.056-1.861,1.075-3.681-2.214-.519.3,1.925,1.157v0l1.756,1.056-1.559.9,1.9,1.144.088,0,3.93.233.31.018,1.289-.525h0l1.124-.46.036-.014,2.079-.85.445-.181.641-.369,1.414-.816h0l.826-.477h0l1.554-.9h0l.825-.477Z",
    transform: "translate(-29.02 -16.865)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78682",
    "data-name": "Path 78682",
    className: "cls-18",
    d: "M167.88,87.624l-3.8,2.19-.519.3-6.305-6.537,1.925,1.157,0,0,4.015,2.415.359.216Z",
    transform: "translate(-31.312 -16.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78683",
    "data-name": "Path 78683",
    className: "cls-38",
    d: "M160.675,88.263s-2.469.186-2.87.2a12.637,12.637,0,0,0-2.336,1.335l-2.336,2.3L151.064,93.3l-1.178.367.8.432,4.24.251,5.094-2.1,4.314-2.49-2.072-.423Z",
    transform: "translate(-29.844 -17.574)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72775",
    "data-name": "Group 72775",
    className: "cls-31",
    transform: "translate(120.042 71.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72774",
    "data-name": "Group 72774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72773",
    "data-name": "Group 72773",
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78684",
    "data-name": "Path 78684",
    className: "cls-40",
    d: "M162.753,89.726l-1.176.837-2.164.791-.745.867-3.148,1.189-3.954.473-.5-.294-1.178.367.8.432,4.241.251,5.094-2.1,4.314-2.49Z",
    transform: "translate(-149.886 -89.726)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_78685",
    "data-name": "Path 78685",
    className: "cls-41",
    d: "M180.256,86.625l-1.346-2-2-.46h0l-2.422.989-11.815,6.82,2.423-.989h0l2,.46,1.346,2,2.135,11.14-.511,3.06,11.817-6.822.51-3.061Z",
    transform: "translate(-32.39 -16.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78686",
    "data-name": "Path 78686",
    className: "cls-42",
    d: "M181.689,87.237l-11.816,6.822,2.135,11.14,11.816-6.823Z",
    transform: "translate(-33.824 -17.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78687",
    "data-name": "Path 78687",
    className: "cls-43",
    d: "M168.192,91.559l1.346,2,11.816-6.822-1.346-2Z",
    transform: "translate(-33.489 -16.872)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78688",
    "data-name": "Path 78688",
    className: "cls-44",
    d: "M179.512,84.622,167.7,91.444l-2-.46,11.816-6.822Z",
    transform: "translate(-32.993 -16.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78689",
    "data-name": "Path 78689",
    className: "cls-18",
    d: "M161.21,92.49l2,.46,1.346,2,2.135,11.14-.511,3.06c0,.427-3.017,1.507-4.78.6s-6.22-5.562-6.22-5.562L143.153,91.722l5.942,3.574,4.576.27Z",
    transform: "translate(-28.503 -18.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78690",
    "data-name": "Path 78690",
    className: "cls-45",
    d: "M164.689,109.362a2.489,2.489,0,0,1-1.113-.215c-1.148-.593-4.221-3.575-5.889-5.315L151.2,97.1l4.286.253,7.435-3.033,1.122.259.926,1.376,2.044,10.666-.394,2.364a5.531,5.531,0,0,1-1.927.372",
    transform: "translate(-30.105 -18.781)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78691",
    "data-name": "Path 78691",
    className: "cls-46",
    d: "M165.145,109.641a2.489,2.489,0,0,1-1.113-.215c-1.148-.593-4.221-3.575-5.889-5.315L152.1,97.85,151.2,97.8l6.49,6.728c1.667,1.74,4.74,4.721,5.889,5.315a2.48,2.48,0,0,0,1.113.215,5.51,5.51,0,0,0,1.927-.372l.046-.272a5.485,5.485,0,0,1-1.516.231",
    transform: "translate(-30.105 -19.472)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78692",
    "data-name": "Path 78692",
    className: "cls-41",
    d: "M179.083,85.971l-.3-3.568.684-.395.3,3.568Z",
    transform: "translate(-35.598 -16.329)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78693",
    "data-name": "Path 78693",
    className: "cls-41",
    d: "M178.28,82.288l-2.036-.462.684-.395,2.036.462Z",
    transform: "translate(-35.092 -16.214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78694",
    "data-name": "Path 78694",
    className: "cls-41",
    d: "M173.917,82.6l1.864-.771.684-.395L174.6,82.2Z",
    transform: "translate(-34.629 -16.214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78695",
    "data-name": "Path 78695",
    className: "cls-18",
    d: "M177.817,82.386l-2.036-.462-1.864.771.754,3.371,1.406-.574,2.036.462Z",
    transform: "translate(-34.629 -16.312)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78696",
    "data-name": "Path 78696",
    className: "cls-19",
    d: "M180.162,90.7l-.207-1.156.413-.239.207,1.156Z",
    transform: "translate(-35.831 -17.781)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78697",
    "data-name": "Path 78697",
    className: "cls-41",
    d: "M179.746,89.395l-.838-.594.414-.239.838.594Z",
    transform: "translate(-35.623 -17.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78698",
    "data-name": "Path 78698",
    className: "cls-41",
    d: "M177.766,89.27l.915-.469.413-.239-.915.469Z",
    transform: "translate(-35.395 -17.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78699",
    "data-name": "Path 78699",
    className: "cls-18",
    d: "M179.519,89.454l-.838-.594-.915.469.915,1.225.288.719.756-.663Z",
    transform: "translate(-35.395 -17.693)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78700",
    "data-name": "Path 78700",
    className: "cls-47",
    d: "M180.316,81.1l-9.072-8.24.386,2.037,7.327,6.682.1,1.459-1.985,3.055.356,1.712,3.068-4.821Z",
    transform: "translate(-34.097 -14.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78701",
    "data-name": "Path 78701",
    className: "cls-20",
    d: "M182.753,84.934l-.181-1.883.684-.395.181,1.883Z",
    transform: "translate(-36.352 -16.458)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78702",
    "data-name": "Path 78702",
    className: "cls-25",
    d: "M182.035,85.4l-3.068,4.821.684-.395,3.068-4.821Z",
    transform: "translate(-35.634 -16.926)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78703",
    "data-name": "Path 78703",
    className: "cls-26",
    d: "M180.316,81l-9.072-8.24.684-.395L181,80.607Z",
    transform: "translate(-34.097 -14.409)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78704",
    "data-name": "Path 78704",
    className: "cls-6",
    d: "M182.143,84.5a.383.383,0,0,1-.107.3,3.838,3.838,0,0,1-.4.255l-.717-1.23a3.618,3.618,0,0,0,.323-.2.335.335,0,0,1,.393.012,1.112,1.112,0,0,1,.505.871",
    transform: "translate(-36.024 -16.638)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78705",
    "data-name": "Path 78705",
    className: "cls-48",
    d: "M181.756,84.781c0,.32-.226.449-.505.288a1.115,1.115,0,0,1-.505-.872c0-.32.227-.449.505-.288a1.112,1.112,0,0,1,.505.871",
    transform: "translate(-35.988 -16.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78706",
    "data-name": "Path 78706",
    className: "cls-6",
    d: "M172.643,74.917a.382.382,0,0,1-.107.3,3.836,3.836,0,0,1-.4.255l-.717-1.23a3.623,3.623,0,0,0,.323-.2.335.335,0,0,1,.393.012,1.114,1.114,0,0,1,.505.871",
    transform: "translate(-34.132 -14.729)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78707",
    "data-name": "Path 78707",
    className: "cls-48",
    d: "M172.255,75.2c0,.32-.226.449-.505.288a1.116,1.116,0,0,1-.505-.872c0-.32.227-.448.505-.287a1.111,1.111,0,0,1,.505.871",
    transform: "translate(-34.097 -14.785)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78708",
    "data-name": "Path 78708",
    className: "cls-19",
    d: "M179.128,91.295l-.207-1.156.413-.239.207,1.156Z",
    transform: "translate(-35.625 -17.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78709",
    "data-name": "Path 78709",
    className: "cls-43",
    d: "M178.713,89.991l-.838-.594.414-.239.838.6Z",
    transform: "translate(-35.417 -17.752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78710",
    "data-name": "Path 78710",
    className: "cls-41",
    d: "M176.733,89.867l.915-.469.413-.239-.915.469Z",
    transform: "translate(-35.19 -17.753)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78711",
    "data-name": "Path 78711",
    className: "cls-18",
    d: "M178.486,90.051l-.838-.594-.915.469.915,1.225.288.718.756-.662Z",
    transform: "translate(-35.189 -17.812)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78712",
    "data-name": "Path 78712",
    className: "cls-28",
    d: "M178.7,90.767a.273.273,0,0,1-.078.213,2.68,2.68,0,0,1-.287.184l-.517-.888a2.7,2.7,0,0,0,.233-.147.243.243,0,0,1,.284.008.806.806,0,0,1,.364.63",
    transform: "translate(-35.405 -17.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78713",
    "data-name": "Path 78713",
    className: "cls-49",
    d: "M178.416,90.969c0,.231-.163.324-.364.208a.8.8,0,0,1-.365-.63c0-.231.163-.324.365-.208a.806.806,0,0,1,.364.63",
    transform: "translate(-35.379 -17.978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78714",
    "data-name": "Path 78714",
    className: "cls-28",
    d: "M171.541,64.923l.089-.012c.227-.03.393.039.43.177l3.589,14.769a.41.41,0,0,1-.345.5.543.543,0,0,1-.6-.41l-3.568-14.688c-.044-.181.165-.308.405-.34",
    transform: "translate(-34.074 -12.923)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78715",
    "data-name": "Path 78715",
    className: "cls-22",
    d: "M170.84,58.689a.56.56,0,0,0,.186-.42c-.015-.18-5.822-24.48-5.822-24.48l-2,.572s5.782,24.218,5.8,24.352c.019.175.167.321.426.385a1.628,1.628,0,0,0,1.415-.408",
    transform: "translate(-32.496 -6.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78716",
    "data-name": "Path 78716",
    className: "cls-26",
    d: "M165.031,34.2c.324-.338.216-.7-.242-.815a1.627,1.627,0,0,0-1.414.408c-.324.338-.216.7.242.815a1.627,1.627,0,0,0,1.414-.408",
    transform: "translate(-32.493 -6.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78717",
    "data-name": "Path 78717",
    className: "cls-22",
    d: "M90.248,55.253a.56.56,0,0,0,.4-.232c.094-.155,9.613-23.255,9.613-23.255L98.3,31.059s-9.492,23.018-9.558,23.134a.489.489,0,0,0,.119.562,1.629,1.629,0,0,0,1.386.5",
    transform: "translate(-17.66 -6.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78718",
    "data-name": "Path 78718",
    className: "cls-26",
    d: "M102.211,31.995c.461-.084.586-.444.281-.8a1.626,1.626,0,0,0-1.386-.5c-.46.084-.586.443-.281.8a1.629,1.629,0,0,0,1.386.5",
    transform: "translate(-20.042 -6.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78719",
    "data-name": "Path 78719",
    className: "cls-14",
    d: "M70.461,35.494,46.569,49.288l-.363-15.433L70.1,20.061l.364.627Z",
    transform: "translate(-9.2 -3.994)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78720",
    "data-name": "Path 78720",
    className: "cls-50",
    d: "M57.358,35.98l-8.6,4.923V35.21l-.4-.583,8.944-5.7Z",
    transform: "translate(-9.628 -5.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78721",
    "data-name": "Path 78721",
    className: "cls-12",
    d: "M70.552,28.483,46.659,42.277v1.257L70.552,29.74Z",
    transform: "translate(-9.29 -5.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78722",
    "data-name": "Path 78722",
    className: "cls-14",
    d: "M48.405,35.99v6.55l.364-.23V36.617Z",
    transform: "translate(-9.638 -7.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78723",
    "data-name": "Path 78723",
    className: "cls-22",
    d: "M36.783,0l31.14,16.067.364.627V31.5L37.755,13.873l-.636-1.149-.454-1.566L35.284,3.931,36.147.154Z",
    transform: "translate(-7.025 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78724",
    "data-name": "Path 78724",
    className: "cls-26",
    d: "M31.847,0,10.5,12.355l5.034,3.9L39.1,29.861,62.988,16.067,39.441,2.472Z",
    transform: "translate(-2.09 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78725",
    "data-name": "Path 78725",
    className: "cls-22",
    d: "M48.177,22.986,38.66,28.421l-.038.053.255.159,9.351-5.538Z",
    transform: "translate(-7.69 -4.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78726",
    "data-name": "Path 78726",
    className: "cls-51",
    d: "M47.985,22.837l-9.316,5.554.167.1,9.35-5.538Z",
    transform: "translate(-7.699 -4.547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78727",
    "data-name": "Path 78727",
    className: "cls-22",
    d: "M47.433,22.548l-9.517,5.435-.038.053.255.159,9.351-5.538Z",
    transform: "translate(-7.542 -4.489)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78728",
    "data-name": "Path 78728",
    className: "cls-51",
    d: "M47.241,22.4l-9.316,5.554.167.1,9.35-5.538Z",
    transform: "translate(-7.551 -4.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78729",
    "data-name": "Path 78729",
    className: "cls-22",
    d: "M46.689,22.109l-9.517,5.435-.038.053.255.159,9.351-5.538Z",
    transform: "translate(-7.394 -4.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78730",
    "data-name": "Path 78730",
    className: "cls-51",
    d: "M46.5,21.96l-9.316,5.554.167.1,9.35-5.538Z",
    transform: "translate(-7.403 -4.372)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78731",
    "data-name": "Path 78731",
    className: "cls-22",
    d: "M45.946,21.671l-9.517,5.435-.038.052.255.159L46,21.779Z",
    transform: "translate(-7.246 -4.315)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78732",
    "data-name": "Path 78732",
    className: "cls-51",
    d: "M45.754,21.521l-9.316,5.554.167.1,9.35-5.538Z",
    transform: "translate(-7.255 -4.285)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78733",
    "data-name": "Path 78733",
    className: "cls-22",
    d: "M45.2,21.232l-9.517,5.435-.038.053.255.159,9.351-5.538Z",
    transform: "translate(-7.098 -4.228)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78734",
    "data-name": "Path 78734",
    className: "cls-51",
    d: "M45.01,21.083l-9.316,5.554.167.1,9.35-5.538Z",
    transform: "translate(-7.107 -4.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78735",
    "data-name": "Path 78735",
    className: "cls-22",
    d: "M44.458,20.794l-9.517,5.435-.038.053.255.159L44.51,20.9Z",
    transform: "translate(-6.95 -4.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78736",
    "data-name": "Path 78736",
    className: "cls-51",
    d: "M44.267,20.644,34.951,26.2l.167.1,9.35-5.538Z",
    transform: "translate(-6.959 -4.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78737",
    "data-name": "Path 78737",
    className: "cls-22",
    d: "M61.3,15.178l-9.517,5.435-.038.053.255.159,9.351-5.538Z",
    transform: "translate(-10.304 -3.022)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78738",
    "data-name": "Path 78738",
    className: "cls-51",
    d: "M61.113,15.029,51.8,20.583l.167.1,9.35-5.538Z",
    transform: "translate(-10.313 -2.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78739",
    "data-name": "Path 78739",
    className: "cls-22",
    d: "M60.561,14.739l-9.517,5.435-.038.053.255.159,9.351-5.538Z",
    transform: "translate(-10.156 -2.935)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78740",
    "data-name": "Path 78740",
    className: "cls-51",
    d: "M60.369,14.59l-9.316,5.554.166.1,9.351-5.538Z",
    transform: "translate(-10.165 -2.905)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78741",
    "data-name": "Path 78741",
    className: "cls-22",
    d: "M59.817,14.3,50.3,19.736l-.038.053.255.159,9.351-5.538Z",
    transform: "translate(-10.008 -2.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78742",
    "data-name": "Path 78742",
    className: "cls-51",
    d: "M59.626,14.152,50.31,19.706l.166.1,9.351-5.538Z",
    transform: "translate(-10.017 -2.818)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78743",
    "data-name": "Path 78743",
    className: "cls-22",
    d: "M59.074,13.862,49.557,19.3l-.038.053.255.159,9.351-5.538Z",
    transform: "translate(-9.86 -2.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78744",
    "data-name": "Path 78744",
    className: "cls-51",
    d: "M58.882,13.713l-9.316,5.554.166.1,9.351-5.538Z",
    transform: "translate(-9.869 -2.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78745",
    "data-name": "Path 78745",
    className: "cls-22",
    d: "M58.33,13.424l-9.517,5.435-.038.053.255.159,9.351-5.538Z",
    transform: "translate(-9.712 -2.673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78746",
    "data-name": "Path 78746",
    className: "cls-51",
    d: "M58.138,13.275l-9.316,5.554.166.1,9.351-5.538Z",
    transform: "translate(-9.721 -2.643)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78747",
    "data-name": "Path 78747",
    className: "cls-22",
    d: "M57.586,12.986,48.069,18.42l-.038.052.255.159,9.351-5.538Z",
    transform: "translate(-9.563 -2.586)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78748",
    "data-name": "Path 78748",
    className: "cls-51",
    d: "M57.395,12.836l-9.316,5.555.166.1L57.6,12.955Z",
    transform: "translate(-9.573 -2.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78749",
    "data-name": "Path 78749",
    className: "cls-18",
    d: "M28.674,19.559,22.853,16.4l-6.416-3.488,0-.485h1.189l10.81,4.036,1.471,1.16v2.618Z",
    transform: "translate(-3.272 -2.474)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78750",
    "data-name": "Path 78750",
    className: "cls-41",
    d: "M45.115,12.978,33.253,19.826V17.207L45.115,10.36Z",
    transform: "translate(-6.621 -2.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78751",
    "data-name": "Path 78751",
    className: "cls-19",
    d: "M41.766,9.068l-1.471-1.16L29.484,3.873H28.3L16.434,10.72h1.189l10.81,4.036,1.471,1.16Z",
    transform: "translate(-3.272 -0.771)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78752",
    "data-name": "Path 78752",
    className: "cls-43",
    d: "M43.278,8.912l-11.86,6.848,1.471,1.16,11.86-6.848Z",
    transform: "translate(-6.256 -1.774)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78753",
    "data-name": "Path 78753",
    className: "cls-36",
    d: "M29.484,3.873,17.624,10.72H16.435L28.3,3.873Z",
    transform: "translate(-3.272 -0.771)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78754",
    "data-name": "Path 78754",
    className: "cls-52",
    d: "M17.919,10.72l11.051,3.9,1.231.876L41.453,9.068l-1.142-1-10.532-4.2L40.59,7.908l1.472,1.16L30.2,15.916l-1.471-1.16Z",
    transform: "translate(-3.568 -0.771)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78755",
    "data-name": "Path 78755",
    className: "cls-27",
    d: "M29.782,20.286H27.2l-1.941-.935-9.442-6.364.5-.315,0,.284Z",
    transform: "translate(-3.149 -2.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78756",
    "data-name": "Path 78756",
    className: "cls-53",
    d: "M31.663,16.221l-.246-.068,5.3-3.051.246.069Z",
    transform: "translate(-6.255 -2.609)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78757",
    "data-name": "Path 78757",
    className: "cls-53",
    d: "M38.736,12.149l-.246-.068,5.3-3.051.246.068Z",
    transform: "translate(-7.664 -1.798)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78758",
    "data-name": "Path 78758",
    className: "cls-53",
    d: "M30.589,15.823l-.246-.068,5.3-3.051.246.068Z",
    transform: "translate(-6.042 -2.529)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78759",
    "data-name": "Path 78759",
    className: "cls-53",
    d: "M37.662,11.75l-.246-.068,5.3-3.051.246.068Z",
    transform: "translate(-7.45 -1.719)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78760",
    "data-name": "Path 78760",
    className: "cls-53",
    d: "M29.515,15.425l-.246-.068,5.3-3.051.246.068Z",
    transform: "translate(-5.828 -2.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78761",
    "data-name": "Path 78761",
    className: "cls-53",
    d: "M36.588,11.353l-.246-.068,5.3-3.051.246.068Z",
    transform: "translate(-7.236 -1.639)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78762",
    "data-name": "Path 78762",
    className: "cls-53",
    d: "M28.441,15.027l-.246-.068,5.3-3.051.246.068Z",
    transform: "translate(-5.614 -2.371)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78763",
    "data-name": "Path 78763",
    className: "cls-53",
    d: "M35.515,10.955l-.246-.068,5.3-3.051.246.068Z",
    transform: "translate(-7.022 -1.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78764",
    "data-name": "Path 78764",
    className: "cls-53",
    d: "M27.368,14.629l-.246-.068,5.3-3.051.246.068Z",
    transform: "translate(-5.4 -2.292)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78765",
    "data-name": "Path 78765",
    className: "cls-53",
    d: "M34.441,10.557l-.246-.068,5.3-3.051.246.067Z",
    transform: "translate(-6.809 -1.481)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78766",
    "data-name": "Path 78766",
    className: "cls-53",
    d: "M26.294,14.231l-.246-.068,5.3-3.051.246.069Z",
    transform: "translate(-5.186 -2.212)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78767",
    "data-name": "Path 78767",
    className: "cls-53",
    d: "M33.367,10.159l-.246-.068,5.3-3.051.246.068Z",
    transform: "translate(-6.595 -1.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78768",
    "data-name": "Path 78768",
    className: "cls-53",
    d: "M25.22,13.833l-.246-.068,5.3-3.051.246.068Z",
    transform: "translate(-4.973 -2.133)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78769",
    "data-name": "Path 78769",
    className: "cls-53",
    d: "M32.293,9.761l-.246-.068,5.3-3.051.246.068Z",
    transform: "translate(-6.381 -1.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78770",
    "data-name": "Path 78770",
    className: "cls-53",
    d: "M24.147,13.435l-.246-.068,5.3-3.051.246.068Z",
    transform: "translate(-4.759 -2.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78771",
    "data-name": "Path 78771",
    className: "cls-53",
    d: "M31.22,9.363l-.246-.068,5.3-3.051.246.068Z",
    transform: "translate(-6.167 -1.243)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78772",
    "data-name": "Path 78772",
    className: "cls-53",
    d: "M23.073,13.037l-.246-.068,5.3-3.051.246.068Z",
    transform: "translate(-4.545 -1.975)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78773",
    "data-name": "Path 78773",
    className: "cls-53",
    d: "M30.146,8.965,29.9,8.9l5.3-3.051.246.068Z",
    transform: "translate(-5.953 -1.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78774",
    "data-name": "Path 78774",
    className: "cls-53",
    d: "M22,12.639l-.246-.068,5.3-3.051.246.068Z",
    transform: "translate(-4.331 -1.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78775",
    "data-name": "Path 78775",
    className: "cls-53",
    d: "M29.072,8.567,28.826,8.5l5.3-3.051.246.068Z",
    transform: "translate(-5.74 -1.085)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78776",
    "data-name": "Path 78776",
    className: "cls-53",
    d: "M20.925,12.241l-.246-.068,5.3-3.051.246.068Z",
    transform: "translate(-4.118 -1.816)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78777",
    "data-name": "Path 78777",
    className: "cls-53",
    d: "M28,8.169,27.753,8.1l5.3-3.051.246.068Z",
    transform: "translate(-5.526 -1.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78778",
    "data-name": "Path 78778",
    className: "cls-53",
    d: "M19.852,11.843l-.246-.068,5.3-3.051.246.067Z",
    transform: "translate(-3.904 -1.737)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78779",
    "data-name": "Path 78779",
    className: "cls-53",
    d: "M26.925,7.771,26.679,7.7l5.3-3.051.246.068Z",
    transform: "translate(-5.312 -0.926)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78780",
    "data-name": "Path 78780",
    className: "cls-53",
    d: "M18.778,11.445l-.246-.068,5.3-3.051.246.068Z",
    transform: "translate(-3.69 -1.658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78781",
    "data-name": "Path 78781",
    className: "cls-53",
    d: "M25.851,7.373l-.246-.068,5.3-3.051.246.068Z",
    transform: "translate(-5.098 -0.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78782",
    "data-name": "Path 78782",
    className: "cls-17",
    d: "M15.089,19.326l-5.034-3.9-.637.155-.863,3.776-.272,8.184.454,1.566.637,1.149,5.715,4.5,23.93,13.605V33.559l-.364-.626Z",
    transform: "translate(-1.649 -3.072)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78783",
    "data-name": "Path 78783",
    className: "cls-54",
    d: "M15.134,27.207l-6.581-5.1-.042,1.277,6.623,5.131,23.93,13.816V41.023Z",
    transform: "translate(-1.695 -4.402)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72778",
    "data-name": "Group 72778",
    className: "cls-55",
    transform: "translate(8.406 12.355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72777",
    "data-name": "Group 72777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72776",
    "data-name": "Group 72776",
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78784",
    "data-name": "Path 78784",
    className: "cls-57",
    d: "M10.5,15.426l5.152,3.632L39.1,32.516l1.06-.625-6.5-3.849,11.185-6.384-.22,1.028-3.808,9.254-1.72.993L15.529,19.327Z",
    transform: "translate(-10.495 -15.426)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_78785",
    "data-name": "Path 78785",
    className: "cls-25",
    d: "M60.046,25.531,53.587,21.8,40.29,29.48l6.459,3.729Z",
    transform: "translate(-8.022 -4.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78786",
    "data-name": "Path 78786",
    className: "cls-28",
    d: "M101.456,29.166l-.091-.093a.524.524,0,0,1-.111-.568l3.908-9.441.935.95-3.715,8.972a.566.566,0,0,1-.927.18",
    transform: "translate(-20.153 -3.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78787",
    "data-name": "Path 78787",
    className: "cls-58",
    d: "M98.14,22.087l-.65.827A6.822,6.822,0,0,0,96.2,26.383v5.11c0,.976,1.185,1.064,1.559-.255l.385-.621a4.892,4.892,0,0,0,.97-2.989l.205-4.756c.312-.983-.466-1.724-1.179-.784",
    transform: "translate(-19.154 -4.312)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78788",
    "data-name": "Path 78788",
    className: "cls-59",
    d: "M98.18,22.479l-.332.463a6.822,6.822,0,0,0-1.291,3.469v5.11c0,.976.578,1.006,1.291.066l.654-.943a4.892,4.892,0,0,0,.97-2.99v-5.11c0-.975-.578-1.005-1.291-.066",
    transform: "translate(-19.226 -4.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78789",
    "data-name": "Path 78789",
    className: "cls-59",
    d: "M96.782,21.226v9.256a1.718,1.718,0,0,0,.239.038.632.632,0,0,0,.119-.082.992.992,0,0,0,.091-.137l-.012-9.292a1.012,1.012,0,0,0-1.655-.8l-3,2.513.259.6,2.927-2.579a.622.622,0,0,1,1.03.485",
    transform: "translate(-18.431 -3.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78790",
    "data-name": "Path 78790",
    className: "cls-6",
    d: "M73.2,6.494l14.937,9.23.909,1.307.364,1.044-.5.337,1.942,17.916.318,5.919-.59,4.246-.273,2.033-.272,1.84L74.7,59.294,68.408,26.363,72.656,6.545Z",
    transform: "translate(-13.621 -1.293)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78791",
    "data-name": "Path 78791",
    className: "cls-60",
    d: "M69.9,6.545,54.564,15.473l.545-.05L70.569,6.5Z",
    transform: "translate(-10.864 -1.294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78792",
    "data-name": "Path 78792",
    className: "cls-61",
    d: "M91.833,41.727l-1.6.927-4.5,2.6-7.8,4.5L75.93,30.813l5-2.885,7.646-4.414,1.253-.724Z",
    transform: "translate(-15.119 -4.538)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78793",
    "data-name": "Path 78793",
    className: "cls-61",
    d: "M92.332,46.435,90.7,48.982l-1.664,2.6-.344.537-7.521,4.342-2.737-2,7.8-4.5,4.5-2.6Z",
    transform: "translate(-15.617 -9.246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78794",
    "data-name": "Path 78794",
    className: "cls-25",
    d: "M92.735,51.135,88.9,56.013,80.88,60.685,77.4,60.063l-1.136,8.119L91.6,59.255Z",
    transform: "translate(-15.185 -10.182)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78795",
    "data-name": "Path 78795",
    className: "cls-62",
    d: "M76.6,66.343l4.581-2.455L81.867,62l6.715-3.984,1.188.577,2.17-1.175.863-6.28-3.831,4.878-8.024,4.672-3.481-.621Z",
    transform: "translate(-15.253 -10.182)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78796",
    "data-name": "Path 78796",
    className: "cls-63",
    d: "M91.434,40.123l-7.428-4.288L81.872,30.8l.239-2.7,7.645-4.414Z",
    transform: "translate(-16.302 -4.718)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78797",
    "data-name": "Path 78797",
    className: "cls-64",
    d: "M70.7,6.5,55.244,15.423l14.937,9.231,15.335-8.928Z",
    transform: "translate(-11 -1.294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78798",
    "data-name": "Path 78798",
    className: "cls-63",
    d: "M91.929,44.778l-.022,1.394-.026,1.62-1.664,2.6L87.41,48.767l-2.147-1.239-.9-2.965.017-4.108Z",
    transform: "translate(-16.797 -8.055)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78799",
    "data-name": "Path 78799",
    className: "cls-17",
    d: "M54.053,17.643l14.937,9.23L69.9,28.18l.364,1.044-.5.337L71.7,47.476l.318,5.919-.59,4.247-.273,2.032-.272,1.84L49.26,49.029V37.511l4.247-19.818Z",
    transform: "translate(-9.808 -3.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78800",
    "data-name": "Path 78800",
    className: "cls-8",
    d: "M69.762,29.561l.5-.337L69.9,28.18l-.908-1.307-14.937-9.23-.545.05L49.26,37.511l1.456,7.852,2.676,4.406,17.768,9.9.863-6.279L71.7,47.477Z",
    transform: "translate(-9.808 -3.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78801",
    "data-name": "Path 78801",
    className: "cls-6",
    d: "M69.074,28.679l2.26,19.455v6.534l-.985,3.6L58.128,51.215,52.92,43.262l-.879-3.924,2.082-12.261L55.59,20.83Z",
    transform: "translate(-10.362 -4.147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78802",
    "data-name": "Path 78802",
    className: "cls-65",
    d: "M72.285,49.706l-7.428-4.29-2.134-5.029.836-9.434.352-3.972,3.26,1.846,3.166,1.794Z",
    transform: "translate(-12.489 -5.373)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78803",
    "data-name": "Path 78803",
    className: "cls-65",
    d: "M65.23,51.6l-.018,4.108.9,2.966,5.913,3.413.686-2.076.067-4.088Z",
    transform: "translate(-12.984 -10.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78804",
    "data-name": "Path 78804",
    className: "cls-65",
    d: "M59.98,25l-.8,6.723-.777,6.559-3.18,2.209L53.7,38.619l2.021-10.334,1.151-5.079.956.552Z",
    transform: "translate(-10.693 -4.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78805",
    "data-name": "Path 78805",
    className: "cls-58",
    d: "M68.055,36.784l-.872.088a2.031,2.031,0,0,0-1.291,2.034v5.665c0,.975.578,1.647,1.291,1.5l1.193-.21c.714-.147.97-.936.97-1.912V38.284c0-.975-.578-1.647-1.291-1.5",
    transform: "translate(-13.12 -7.32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78806",
    "data-name": "Path 78806",
    className: "cls-59",
    d: "M68.055,36.982l-.872.088A2.031,2.031,0,0,0,65.892,39.1v5.665c0,.975.578,1.647,1.291,1.5l1.193-.21c.714-.147.97-.936.97-1.912V38.482c0-.975-.578-1.647-1.291-1.5",
    transform: "translate(-13.12 -7.36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78807",
    "data-name": "Path 78807",
    className: "cls-59",
    d: "M72.524,30.936,69.29,34.1a4.164,4.164,0,0,0-1.241,2.976v7.1a.141.141,0,0,0,.041.024.923.923,0,0,0,.166.051.341.341,0,0,0,.333-.073V37.382a4.171,4.171,0,0,1,1.193-2.929l2.985-3.022.034-.368Z",
    transform: "translate(-13.549 -6.16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78808",
    "data-name": "Path 78808",
    className: "cls-22",
    d: "M31.053.154,9.7,12.509l.636-.154L31.689,0Z",
    transform: "translate(-1.932 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78809",
    "data-name": "Path 78809",
    className: "cls-66",
    d: "M75.167,29.3,90.5,20.371l-.364-1.044L89.23,18.02,73.9,26.948l.908,1.307Z",
    transform: "translate(-14.713 -3.588)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78810",
    "data-name": "Path 78810",
    className: "cls-41",
    d: "M173.1,89.423l-.3-3.568.684-.395.3,3.568Z",
    transform: "translate(-34.408 -17.016)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78811",
    "data-name": "Path 78811",
    className: "cls-41",
    d: "M172.3,85.74l-2.036-.462.684-.395,2.036.462Z",
    transform: "translate(-33.902 -16.901)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78812",
    "data-name": "Path 78812",
    className: "cls-41",
    d: "M167.938,86.049l1.864-.771.684-.395-1.864.771Z",
    transform: "translate(-33.438 -16.901)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78813",
    "data-name": "Path 78813",
    className: "cls-18",
    d: "M171.838,85.838l-2.036-.462-1.864.771.754,3.371,1.406-.574,2.036.462Z",
    transform: "translate(-33.438 -16.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78814",
    "data-name": "Path 78814",
    className: "cls-30",
    d: "M156.264,21.787l-3.227,1.863,5.439,7.5,3.227-1.863Z",
    transform: "translate(-30.472 -4.338)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78815",
    "data-name": "Path 78815",
    className: "cls-26",
    d: "M153.892,21.844l-3.227,1.863,1.9-.057,3.227-1.864Z",
    transform: "translate(-29.999 -4.338)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78816",
    "data-name": "Path 78816",
    className: "cls-19",
    d: "M176.543,92.778l-.207-1.156.413-.239.207,1.156Z",
    transform: "translate(-35.111 -18.196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78817",
    "data-name": "Path 78817",
    className: "cls-41",
    d: "M176.128,91.475l-.838-.594.414-.239.838.594Z",
    transform: "translate(-34.902 -18.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78818",
    "data-name": "Path 78818",
    className: "cls-41",
    d: "M174.148,91.35l.915-.469.413-.239-.915.469Z",
    transform: "translate(-34.675 -18.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78819",
    "data-name": "Path 78819",
    className: "cls-18",
    d: "M175.9,91.534l-.838-.594-.915.469.915,1.225.288.719.756-.663Z",
    transform: "translate(-34.675 -18.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78820",
    "data-name": "Path 78820",
    className: "cls-47",
    d: "M176.045,83.566l-9.072-8.24.386,2.037,7.327,6.681.1,1.459L172.8,88.558l.356,1.712,3.068-4.821Z",
    transform: "translate(-33.246 -14.998)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78821",
    "data-name": "Path 78821",
    className: "cls-20",
    d: "M178.482,87.4l-.181-1.883.684-.395L179.166,87Z",
    transform: "translate(-35.502 -16.949)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78822",
    "data-name": "Path 78822",
    className: "cls-25",
    d: "M177.764,87.867,174.7,92.689l.684-.395,3.068-4.821Z",
    transform: "translate(-34.784 -17.417)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78823",
    "data-name": "Path 78823",
    className: "cls-26",
    d: "M176.046,83.468l-9.072-8.24.684-.395,9.072,8.24Z",
    transform: "translate(-33.246 -14.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78824",
    "data-name": "Path 78824",
    className: "cls-6",
    d: "M177.873,86.967a.382.382,0,0,1-.107.3,3.84,3.84,0,0,1-.4.255l-.717-1.23a3.617,3.617,0,0,0,.323-.2.335.335,0,0,1,.393.012,1.114,1.114,0,0,1,.505.871",
    transform: "translate(-35.173 -17.129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78825",
    "data-name": "Path 78825",
    className: "cls-48",
    d: "M177.485,87.247c0,.32-.226.449-.505.288a1.116,1.116,0,0,1-.505-.872c0-.32.227-.449.505-.288a1.111,1.111,0,0,1,.505.871",
    transform: "translate(-35.138 -17.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78826",
    "data-name": "Path 78826",
    className: "cls-6",
    d: "M168.372,77.383a.381.381,0,0,1-.107.3,3.84,3.84,0,0,1-.4.255l-.717-1.23a3.759,3.759,0,0,0,.323-.2.333.333,0,0,1,.393.011,1.114,1.114,0,0,1,.505.871",
    transform: "translate(-33.282 -15.221)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78827",
    "data-name": "Path 78827",
    className: "cls-48",
    d: "M167.984,77.662c0,.32-.226.449-.505.288a1.115,1.115,0,0,1-.505-.872c0-.32.227-.449.505-.288a1.111,1.111,0,0,1,.505.871",
    transform: "translate(-33.246 -15.276)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78828",
    "data-name": "Path 78828",
    className: "cls-19",
    d: "M175.51,93.375l-.207-1.156.413-.239.207,1.156Z",
    transform: "translate(-34.905 -18.314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78829",
    "data-name": "Path 78829",
    className: "cls-43",
    d: "M175.095,92.072l-.838-.594.414-.239.838.594Z",
    transform: "translate(-34.697 -18.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78830",
    "data-name": "Path 78830",
    className: "cls-41",
    d: "M173.114,91.946l.915-.469.413-.239-.915.469Z",
    transform: "translate(-34.469 -18.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78831",
    "data-name": "Path 78831",
    className: "cls-18",
    d: "M174.867,92.131l-.838-.594-.915.469.915,1.225.288.719.756-.663Z",
    transform: "translate(-34.469 -18.226)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78832",
    "data-name": "Path 78832",
    className: "cls-67",
    d: "M58.585,15.581,73.692,24.49l.058.086-.43.26L58.492,15.758Z",
    transform: "translate(-11.646 -3.102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78833",
    "data-name": "Path 78833",
    className: "cls-60",
    d: "M58.947,15.336l14.768,9.105-.28.169L58.608,15.532Z",
    transform: "translate(-11.67 -3.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78834",
    "data-name": "Path 78834",
    className: "cls-67",
    d: "M61.713,13.784l15.107,8.909.058.086-.431.261L61.621,13.961Z",
    transform: "translate(-12.27 -2.744)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78835",
    "data-name": "Path 78835",
    className: "cls-60",
    d: "M62.075,13.539l14.768,9.105-.28.169L61.736,13.735Z",
    transform: "translate(-12.292 -2.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78836",
    "data-name": "Path 78836",
    className: "cls-67",
    d: "M64.842,11.987,79.949,20.9l.058.086-.43.26L64.75,12.164Z",
    transform: "translate(-12.892 -2.387)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78837",
    "data-name": "Path 78837",
    className: "cls-60",
    d: "M65.2,11.742l14.768,9.105-.28.169L64.864,11.938Z",
    transform: "translate(-12.915 -2.338)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78838",
    "data-name": "Path 78838",
    className: "cls-67",
    d: "M67.97,10.19,83.077,19.1l.058.086-.43.26L67.878,10.367Z",
    transform: "translate(-13.515 -2.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78839",
    "data-name": "Path 78839",
    className: "cls-60",
    d: "M68.331,9.945,83.1,19.05l-.28.169L67.993,10.141Z",
    transform: "translate(-13.538 -1.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78840",
    "data-name": "Path 78840",
    className: "cls-67",
    d: "M71.1,8.393,86.205,17.3l.058.086-.43.26L71.006,8.57Z",
    transform: "translate(-14.138 -1.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78841",
    "data-name": "Path 78841",
    className: "cls-60",
    d: "M71.46,8.148l14.768,9.105-.28.169L71.121,8.344Z",
    transform: "translate(-14.161 -1.622)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78842",
    "data-name": "Path 78842",
    className: "cls-68",
    d: "M80.643,65.893l-2.2,1.286.141-1.643,2.727-1.218Z",
    transform: "translate(-15.62 -12.806)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78843",
    "data-name": "Path 78843",
    className: "cls-69",
    d: "M80.678,65.814l-.783-.405-1.273.048.172-1.536,2.555.318Z",
    transform: "translate(-15.655 -12.727)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78844",
    "data-name": "Path 78844",
    className: "cls-70",
    d: "M81.312,64.319l-.671,1.575-2.2,1.286-.008.167,2.343-1.372.679-1.531Z",
    transform: "translate(-15.617 -12.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78845",
    "data-name": "Path 78845",
    className: "cls-71",
    d: "M79.316,66.292l-.694.406.022-.453.694-.407Z",
    transform: "translate(-15.655 -13.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78846",
    "data-name": "Path 78846",
    className: "cls-72",
    d: "M78.444,67.572l-.008.167,2.343-1.372-.139-.082Z",
    transform: "translate(-15.617 -13.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78847",
    "data-name": "Path 78847",
    className: "cls-68",
    d: "M94.359,56.89l-1.644.934-.73-.519,2.882-3.711Z",
    transform: "translate(-18.315 -10.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78848",
    "data-name": "Path 78848",
    className: "cls-69",
    d: "M94.359,56.89l-.643-.775-1.467,1.124.466.585-.73-.519,2.882-3.711-.026,1.859Z",
    transform: "translate(-18.315 -10.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78849",
    "data-name": "Path 78849",
    className: "cls-70",
    d: "M95.048,53.573l-.159,1.75-.349,1.546L92.9,57.8l.267.012,1.515-.864.344-1.518.172-1.945Z",
    transform: "translate(-18.497 -10.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78850",
    "data-name": "Path 78850",
    className: "cls-71",
    d: "M93.351,57.572l-.694.406.022-.452.694-.407Z",
    transform: "translate(-18.449 -11.373)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78851",
    "data-name": "Path 78851",
    className: "cls-72",
    d: "M92.9,58.644l.267.012,1.516-.864-.139-.082Z",
    transform: "translate(-18.497 -11.491)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78852",
    "data-name": "Path 78852",
    className: "cls-73",
    d: "M167.157,69.351l-1.476-1.262-2.906-11.31,1.476,1.262Z",
    transform: "translate(-32.411 -11.305)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78853",
    "data-name": "Path 78853",
    className: "cls-74",
    d: "M164.757,60.007l-1.476-1.262-.228-.887,1.477,1.262Z",
    transform: "translate(-32.466 -11.52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78854",
    "data-name": "Path 78854",
    className: "cls-74",
    d: "M165.37,62.394l-1.476-1.262-.228-.887,1.477,1.262Z",
    transform: "translate(-32.588 -11.995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78855",
    "data-name": "Path 78855",
    className: "cls-74",
    d: "M165.983,64.78l-1.476-1.262-.228-.887,1.476,1.262Z",
    transform: "translate(-32.71 -12.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78856",
    "data-name": "Path 78856",
    className: "cls-74",
    d: "M166.6,67.167,165.12,65.9l-.228-.887,1.477,1.262Z",
    transform: "translate(-32.832 -12.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78857",
    "data-name": "Path 78857",
    className: "cls-74",
    d: "M167.209,69.554l-1.476-1.262L165.5,67.4l1.476,1.262Z",
    transform: "translate(-32.954 -13.421)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78858",
    "data-name": "Path 78858",
    className: "cls-74",
    d: "M167.822,71.94l-1.476-1.262-.228-.887,1.477,1.262Z",
    transform: "translate(-33.076 -13.896)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78859",
    "data-name": "Path 78859",
    className: "cls-73",
    d: "M163.53,55.233l-1.476-1.262-2.906-11.31,1.476,1.262Z",
    transform: "translate(-31.688 -8.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78860",
    "data-name": "Path 78860",
    className: "cls-74",
    d: "M161.129,45.888l-1.476-1.262-.228-.887L160.9,45Z",
    transform: "translate(-31.743 -8.709)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78861",
    "data-name": "Path 78861",
    className: "cls-74",
    d: "M161.742,48.275l-1.476-1.262-.228-.887,1.477,1.262Z",
    transform: "translate(-31.865 -9.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78862",
    "data-name": "Path 78862",
    className: "cls-74",
    d: "M162.355,50.661,160.879,49.4l-.228-.887,1.477,1.262Z",
    transform: "translate(-31.988 -9.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78863",
    "data-name": "Path 78863",
    className: "cls-74",
    d: "M162.969,53.048l-1.476-1.262-.228-.887,1.477,1.262Z",
    transform: "translate(-32.11 -10.135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78864",
    "data-name": "Path 78864",
    className: "cls-74",
    d: "M163.582,55.435l-1.476-1.262-.228-.887,1.477,1.262Z",
    transform: "translate(-32.232 -10.61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78865",
    "data-name": "Path 78865",
    className: "cls-74",
    d: "M164.195,57.821l-1.476-1.262-.228-.887,1.477,1.262Z",
    transform: "translate(-32.354 -11.085)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78866",
    "data-name": "Path 78866",
    className: "cls-75",
    d: "M122.285,30.639l1.83-.65,11.252,3.122-1.831.65Z",
    transform: "translate(-24.348 -5.971)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78867",
    "data-name": "Path 78867",
    className: "cls-74",
    d: "M134.159,33.934l1.83-.65.883.245-1.831.65Z",
    transform: "translate(-26.713 -6.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78868",
    "data-name": "Path 78868",
    className: "cls-74",
    d: "M131.785,33.275l1.831-.65.882.245-1.831.65Z",
    transform: "translate(-26.24 -6.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78869",
    "data-name": "Path 78869",
    className: "cls-74",
    d: "M129.41,32.616l1.831-.65.882.245-1.831.65Z",
    transform: "translate(-25.767 -6.365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78870",
    "data-name": "Path 78870",
    className: "cls-74",
    d: "M127.036,31.957l1.83-.65.883.245-1.831.65Z",
    transform: "translate(-25.294 -6.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78871",
    "data-name": "Path 78871",
    className: "cls-74",
    d: "M124.661,31.3l1.831-.65.882.245-1.831.65Z",
    transform: "translate(-24.822 -6.102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78872",
    "data-name": "Path 78872",
    className: "cls-74",
    d: "M122.287,30.64l1.83-.65.883.245-1.831.65Z",
    transform: "translate(-24.349 -5.971)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78873",
    "data-name": "Path 78873",
    className: "cls-28",
    d: "M174.994,92.848a.276.276,0,0,1-.078.215,2.667,2.667,0,0,1-.288.184l-.52-.892s.183-.1.235-.147a.241.241,0,0,1,.284.008.807.807,0,0,1,.367.632",
    transform: "translate(-34.667 -18.351)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78874",
    "data-name": "Path 78874",
    className: "cls-49",
    d: "M174.713,93.05c0,.232-.164.326-.366.209a.807.807,0,0,1-.367-.632c0-.232.164-.326.367-.209a.808.808,0,0,1,.366.632",
    transform: "translate(-34.641 -18.392)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78875",
    "data-name": "Path 78875",
    className: "cls-28",
    d: "M171.717,87.646a.543.543,0,0,1-.152.419,5.458,5.458,0,0,1-.562.36l-1.016-1.742a5.193,5.193,0,0,0,.457-.288.476.476,0,0,1,.557.017,1.578,1.578,0,0,1,.715,1.234",
    transform: "translate(-33.846 -17.186)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78876",
    "data-name": "Path 78876",
    className: "cls-49",
    d: "M171.167,88.042c0,.453-.32.636-.715.408a1.574,1.574,0,0,1-.716-1.234c0-.453.32-.636.716-.408a1.578,1.578,0,0,1,.715,1.234",
    transform: "translate(-33.796 -17.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78877",
    "data-name": "Path 78877",
    className: "cls-6",
    d: "M107.791,19.277a.382.382,0,0,1-.107.3c-.093.082-1.091.7-1.091.7l-.718-1.23s.947-.585,1.017-.645a.335.335,0,0,1,.393.012,1.114,1.114,0,0,1,.505.871",
    transform: "translate(-21.081 -3.651)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78878",
    "data-name": "Path 78878",
    className: "cls-48",
    d: "M106.709,20.107c0,.32-.226.449-.505.288a1.115,1.115,0,0,1-.505-.872c0-.32.227-.448.505-.288a1.112,1.112,0,0,1,.505.871",
    transform: "translate(-21.046 -3.816)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78879",
    "data-name": "Path 78879",
    className: "cls-6",
    d: "M151.679,25.726a.382.382,0,0,1-.107.3c-.093.082-1.091.7-1.091.7l-.718-1.23s.947-.585,1.017-.645a.335.335,0,0,1,.393.012,1.114,1.114,0,0,1,.505.871",
    transform: "translate(-29.82 -4.935)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78880",
    "data-name": "Path 78880",
    className: "cls-48",
    d: "M150.6,26.557c0,.32-.226.449-.505.288a1.116,1.116,0,0,1-.505-.872c0-.32.227-.448.505-.288a1.111,1.111,0,0,1,.505.871",
    transform: "translate(-29.784 -5.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78881",
    "data-name": "Path 78881",
    className: "cls-76",
    d: "M58.315,23.9l2.149,1.241-.8,6.722-3.535,2.081Z",
    transform: "translate(-11.177 -4.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78882",
    "data-name": "Path 78882",
    className: "cls-76",
    d: "M67.379,28.829l-3.611,2.126.352-3.972Z",
    transform: "translate(-12.697 -5.373)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72781",
    "data-name": "Group 72781",
    className: "cls-31",
    transform: "translate(6.634 12.355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72780",
    "data-name": "Group 72780",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72779",
    "data-name": "Group 72779",
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78883",
    "data-name": "Path 78883",
    className: "cls-78",
    d: "M15.089,19.326V34.76l-5.715-4.5-.637-1.149-.454-1.566.272-8.184.863-3.776.637-.155Z",
    transform: "translate(-8.283 -15.426)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72784",
    "data-name": "Group 72784",
    className: "cls-31",
    transform: "translate(22.958 7.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72783",
    "data-name": "Group 72783",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72782",
    "data-name": "Group 72782",
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78884",
    "data-name": "Path 78884",
    className: "cls-80",
    d: "M28.98,39.147h-.315V23.708l23.9-13.879.158.271L28.98,23.889Z",
    transform: "translate(-28.666 -9.828)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72787",
    "data-name": "Group 72787",
    className: "cls-31",
    transform: "translate(13.282 27.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72786",
    "data-name": "Group 72786",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72785",
    "data-name": "Group 72785",
    className: "cls-81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78885",
    "data-name": "Path 78885",
    className: "cls-80",
    d: "M26.336,39.794,16.9,34.433v4h-.314V33.892l9.906,5.629Z",
    transform: "translate(-16.585 -33.892)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_78886",
    "data-name": "Path 78886",
    className: "cls-6",
    d: "M50.61,39.025l-.506-.287a1.617,1.617,0,0,1-.785-1.761L51.962,24.9a2.221,2.221,0,0,1,1.165-1.509l.071-.035.608.017L53.789,24l-.444-.012a1.591,1.591,0,0,0-.768,1.045L49.934,37.112a.991.991,0,0,0,.481,1.079l.506.287Z",
    transform: "translate(-9.812 -4.651)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78887",
    "data-name": "Path 78887",
    className: "cls-6",
    d: "M43.235,49.783a1.15,1.15,0,0,1-.634-.188,1.187,1.187,0,0,1-.537-.995V40.936a2.324,2.324,0,0,1,1.1-1.984l.332-.208.334.533-.333.208a1.7,1.7,0,0,0-.8,1.45V48.6a.558.558,0,0,0,.782.511l.189.261.127.289a1.4,1.4,0,0,1-.555.122",
    transform: "translate(-8.375 -7.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78888",
    "data-name": "Path 78888",
    className: "cls-6",
    d: "M161.647,31.857c-.034-.062-3.427-6.156-4.421-7.468a4.747,4.747,0,0,0-2.9-1.909,2.855,2.855,0,0,0-2.176.778l-.412-.476a3.418,3.418,0,0,1,2.653-.928,5.377,5.377,0,0,1,3.337,2.154c1.02,1.348,4.329,7.29,4.469,7.542Z",
    transform: "translate(-30.213 -4.348)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78889",
    "data-name": "Path 78889",
    className: "cls-6",
    d: "M153.622,38.576a.723.723,0,0,1-.2.56,7.131,7.131,0,0,1-.752.483l-1.359-2.331a7,7,0,0,0,.613-.385.634.634,0,0,1,.745.022,2.11,2.11,0,0,1,.958,1.652",
    transform: "translate(-30.127 -7.326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78890",
    "data-name": "Path 78890",
    className: "cls-48",
    d: "M152.886,39.106c0,.607-.428.851-.957.546A2.11,2.11,0,0,1,150.971,38c0-.606.429-.851.958-.546a2.112,2.112,0,0,1,.957,1.652",
    transform: "translate(-30.06 -7.431)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72790",
    "data-name": "Group 72790",
    className: "cls-31",
    transform: "translate(39.452 44.926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72789",
    "data-name": "Group 72789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72788",
    "data-name": "Group 72788",
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78891",
    "data-name": "Path 78891",
    className: "cls-83",
    d: "M86.294,59.726l-.072.516L70.887,69.171,49.26,56.685v-.59l21.72,12.442Z",
    transform: "translate(-49.26 -56.095)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_78892",
    "data-name": "Path 78892",
    className: "cls-84",
    d: "M55.244,15.424l15.274,9.035.975.866,14.235-8.379-.553-1.021L70.705,6.5l14.812,9.228.908,1.307L71.09,25.961l-.909-1.307Z",
    transform: "translate(-11 -1.294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78893",
    "data-name": "Path 78893",
    className: "cls-59",
    d: "M79.785,28.228l.42-1.241,7.372-4.251.6.609Z",
    transform: "translate(-15.886 -4.527)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78894",
    "data-name": "Path 78894",
    className: "cls-85",
    d: "M81.425,27.54l-.872.5v.418l1.013-.843Z",
    transform: "translate(-16.039 -5.484)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78895",
    "data-name": "Path 78895",
    className: "cls-86",
    d: "M81.6,27.637l-.872.5v.419l.872-.514Z",
    transform: "translate(-16.074 -5.503)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78896",
    "data-name": "Path 78896",
    className: "cls-87",
    d: "M80.694,28.246l-.141-.078v.418l.141.078Z",
    transform: "translate(-16.039 -5.609)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78897",
    "data-name": "Path 78897",
    className: "cls-85",
    d: "M85.126,25.411l-.872.5v.418l1.013-.843Z",
    transform: "translate(-16.776 -5.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78898",
    "data-name": "Path 78898",
    className: "cls-86",
    d: "M85.3,25.508l-.872.5v.418l.872-.513Z",
    transform: "translate(-16.811 -5.079)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78899",
    "data-name": "Path 78899",
    className: "cls-87",
    d: "M84.4,26.117l-.141-.078v.418l.141.078Z",
    transform: "translate(-16.776 -5.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78900",
    "data-name": "Path 78900",
    className: "cls-85",
    d: "M88.827,23.282l-.872.5V24.2l1.013-.844Z",
    transform: "translate(-17.513 -4.636)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78901",
    "data-name": "Path 78901",
    className: "cls-86",
    d: "M89,23.379l-.872.5V24.3L89,23.787Z",
    transform: "translate(-17.548 -4.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78902",
    "data-name": "Path 78902",
    className: "cls-87",
    d: "M88.1,23.988l-.141-.078v.418l.141.078Z",
    transform: "translate(-17.513 -4.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78903",
    "data-name": "Path 78903",
    className: "cls-88",
    d: "M37.886,48.758a.653.653,0,0,1-.324-.1,1.433,1.433,0,0,1-.659-1.137c0-.324.171-.533.437-.533a.646.646,0,0,1,.324.1,1.433,1.433,0,0,1,.659,1.136c0,.324-.171.533-.437.533",
    transform: "translate(-7.348 -9.356)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78904",
    "data-name": "Path 78904",
    className: "cls-89",
    d: "M38.165,48.317c0,.385-.272.541-.608.347a1.341,1.341,0,0,1-.608-1.049c0-.385.272-.54.608-.346a1.34,1.34,0,0,1,.608,1.048",
    transform: "translate(-7.357 -9.395)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78905",
    "data-name": "Path 78905",
    className: "cls-88",
    d: "M19.231,37.99a.653.653,0,0,1-.324-.1,1.433,1.433,0,0,1-.659-1.137c0-.324.171-.533.436-.533a.646.646,0,0,1,.324.1,1.433,1.433,0,0,1,.659,1.136c0,.324-.172.533-.437.533",
    transform: "translate(-3.633 -7.212)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78906",
    "data-name": "Path 78906",
    className: "cls-89",
    d: "M19.51,37.549c0,.385-.272.541-.609.347a1.341,1.341,0,0,1-.608-1.049c0-.385.272-.54.608-.346a1.338,1.338,0,0,1,.609,1.048",
    transform: "translate(-3.642 -7.251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78907",
    "data-name": "Path 78907",
    className: "cls-6",
    d: "M35.33,38.255l.01-.349L24.153,31.447l-.01.349Z",
    transform: "translate(-4.807 -6.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78908",
    "data-name": "Path 78908",
    className: "cls-6",
    d: "M35.33,37.218l.01-.349L24.153,30.41l-.01.349Z",
    transform: "translate(-4.807 -6.055)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78909",
    "data-name": "Path 78909",
    className: "cls-6",
    d: "M35.33,36.181l.01-.349L24.153,29.373l-.01.349Z",
    transform: "translate(-4.807 -5.849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78910",
    "data-name": "Path 78910",
    className: "cls-6",
    d: "M35.33,35.143l.01-.349L24.153,28.336l-.01.349Z",
    transform: "translate(-4.807 -5.642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78911",
    "data-name": "Path 78911",
    className: "cls-6",
    d: "M35.33,34.106l.01-.349L24.153,27.3l-.01.349Z",
    transform: "translate(-4.807 -5.436)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78912",
    "data-name": "Path 78912",
    className: "cls-90",
    d: "M12.717,31.95v.971l-.893-.761V30.89a.5.5,0,0,1,.183-.4.416.416,0,0,1,.539.2.972.972,0,0,1,.092.155,3.806,3.806,0,0,1,.079,1.1",
    transform: "translate(-2.354 -6.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78913",
    "data-name": "Path 78913",
    className: "cls-91",
    d: "M12.547,30.695l-.274,1.243-.448.223V30.89a.5.5,0,0,1,.182-.4.417.417,0,0,1,.54.2",
    transform: "translate(-2.354 -6.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78914",
    "data-name": "Path 78914",
    className: "cls-22",
    d: "M11.825,32.531l.448-.222.447.34,0,.643Z",
    transform: "translate(-2.354 -6.433)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78915",
    "data-name": "Path 78915",
    className: "cls-27",
    d: "M152.752,34.151l-1.773-.157-.692-.525-5.681-2.156-1.27-1.744-2.291-.9,2.291-1.427,2.6.766,2.4.423-3.227,1.864.383.51,5.681,2.156Z",
    transform: "translate(-28.084 -5.423)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72793",
    "data-name": "Group 72793",
    className: "cls-31",
    transform: "translate(62.875 13.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72792",
    "data-name": "Group 72792",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72791",
    "data-name": "Group 72791",
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78916",
    "data-name": "Path 78916",
    className: "cls-93",
    d: "M83.583,18.852,83.436,17.3l-3.794.074v.007a2,2,0,0,0-.806.182c-.467.24-.435.617.071.843a2.02,2.02,0,0,0,.642.141v0Z",
    transform: "translate(-78.507 -17.297)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_78917",
    "data-name": "Path 78917",
    className: "cls-61",
    d: "M83.037,17.068l2.9-.042v1.06h0c.014.177-.113.355-.383.494a2.682,2.682,0,0,1-2.047.033c-.3-.131-.452-.307-.465-.485Z",
    transform: "translate(-16.534 -3.39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78918",
    "data-name": "Path 78918",
    className: "cls-94",
    d: "M83.17,13.782l2.494-.028.268,2.621c.014.176-.113.355-.383.494A2.686,2.686,0,0,1,83.5,16.9c-.3-.131-.452-.307-.465-.485Z",
    transform: "translate(-16.534 -2.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78919",
    "data-name": "Path 78919",
    className: "cls-95",
    d: "M83.534,13.214a2.311,2.311,0,0,1,1.763-.028c.506.224.538.6.071.843a2.311,2.311,0,0,1-1.763.028c-.507-.225-.539-.6-.071-.843",
    transform: "translate(-16.567 -2.593)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78920",
    "data-name": "Path 78920",
    className: "cls-96",
    d: "M83.509,16.408a2.485,2.485,0,0,1,1.9-.03c.546.242.58.649.077.907a2.489,2.489,0,0,1-1.9.03c-.545-.242-.58-.649-.075-.907",
    transform: "translate(-16.557 -3.226)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78921",
    "data-name": "Path 78921",
    className: "cls-96",
    d: "M85.083,15.189a1.968,1.968,0,0,1,.047,1.237c-.137.324-.742.233-.872-.117a.967.967,0,0,1,.045-.857c.138-.324.65-.614.78-.263",
    transform: "translate(-16.761 -2.993)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78922",
    "data-name": "Path 78922",
    className: "cls-95",
    d: "M84.574,15.521a1.9,1.9,0,0,1-.012,1.123c-.115.262-.3.183-.406-.175a1.907,1.907,0,0,1,.013-1.123c.115-.262.3-.183.405.175",
    transform: "translate(-16.741 -3.025)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialMovementsNew);
export default __webpack_public_path__ + "static/media/MaterialMovementsNew.def7e044c9d8334c50b2c76b83e99296.svg";
export { ForwardRef as ReactComponent };